export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalDeliveryField = {
  __typename?: 'AdditionalDeliveryField';
  name: Maybe<Scalars['String']['output']>;
};

export type Age = {
  __typename?: 'Age';
  a: Maybe<Scalars['Int']['output']>;
  b: Maybe<Scalars['Int']['output']>;
};

export type AuthCodeCheckReponse = {
  __typename?: 'AuthCodeCheckReponse';
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type AuthStatus = {
  __typename?: 'AuthStatus';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type AutoSellConfig = {
  __typename?: 'AutoSellConfig';
  organizationId: Maybe<Scalars['ID']['output']>;
  verificationMode: Maybe<AutoSellOrderVerificationMode>;
  verifyOrders: Maybe<Scalars['Boolean']['output']>;
};

export type AutoSellConfigInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  verificationMode?: InputMaybe<AutoSellOrderVerificationMode>;
  verifyOrders?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AutoSellOrderVerificationMode {
  All = 'All',
  None = 'None',
  WithComment = 'WithComment',
}

export type BeginTwoFactorAuthenticatorSetupResponse = {
  __typename?: 'BeginTwoFactorAuthenticatorSetupResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  manualKey: Maybe<Scalars['String']['output']>;
  otpauthUri: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type BlackFridayStatus = {
  __typename?: 'BlackFridayStatus';
  postponed: Maybe<Scalars['Boolean']['output']>;
  used: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerDetails = {
  __typename?: 'BuyerDetails';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type CalendarForDisplay = {
  __typename?: 'CalendarForDisplay';
  calendarForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<CalendarSize>;
};

export enum CalendarSize {
  S20x30 = 's20x30',
  S30x45 = 's30x45',
}

export type CloudAccessToken = {
  __typename?: 'CloudAccessToken';
  container: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  storageAccessToken: Maybe<Scalars['String']['output']>;
  storageUri: Maybe<Scalars['String']['output']>;
  zalamoToken: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  authorId: Maybe<Scalars['ID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  commentId: Maybe<Scalars['ID']['output']>;
  date: Maybe<Scalars['Int']['output']>;
  type: Maybe<CommnetType>;
};

export enum CommentContext {
  Issue = 'Issue',
  Order = 'Order',
  Reservation = 'Reservation',
  SupportThread = 'SupportThread',
}

export type CommentsList = {
  __typename?: 'CommentsList';
  comments: Maybe<Array<Maybe<Comment>>>;
  commentsListId: Maybe<Scalars['ID']['output']>;
};

export enum CommnetType {
  Attachments = 'Attachments',
  Picture = 'Picture',
  Text = 'Text',
}

export type ConfirmDataProcessingAgreementSigningInput = {
  agreementId: Scalars['ID']['input'];
  codes: Array<InputMaybe<DataProcessingAgreementSmsCodeInput>>;
};

export type ConfirmTwoFactorAuthenticatorSetupResponse = {
  __typename?: 'ConfirmTwoFactorAuthenticatorSetupResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  recoveryCodes: Array<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ConversationStatus = {
  __typename?: 'ConversationStatus';
  conversationStatusId: Maybe<Scalars['ID']['output']>;
  lastMessageContent: Maybe<Scalars['String']['output']>;
  unseen: Maybe<Scalars['Boolean']['output']>;
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateSupportIssueFromThreadInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  deadlineDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<SupportIssuePriority>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateSupportIssueInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  deadlineDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<SupportIssuePriority>;
  sourceContext?: InputMaybe<Scalars['String']['input']>;
  sourceContextId?: InputMaybe<Scalars['ID']['input']>;
  sourceConversationId?: InputMaybe<Scalars['ID']['input']>;
  sourceSupportThreadId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<SupportIssueSourceType>;
  supportTeamId?: InputMaybe<Scalars['ID']['input']>;
  supportedUserId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateUploadQueueFileInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  photoId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUploadQueueInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  filesCount?: InputMaybe<Scalars['Int']['input']>;
  filesDone?: InputMaybe<Scalars['Int']['input']>;
  isRetouched?: InputMaybe<Scalars['Boolean']['input']>;
  onDone?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  queueId: Scalars['String']['input'];
  type?: InputMaybe<UploadType>;
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Data = {
  id: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetails = {
  __typename?: 'DataAgreementDetails';
  companyBuildingNumber: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyFlatNumber: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyStreet: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetailsInput = {
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
};

export type DataProcessingAgreement = {
  __typename?: 'DataProcessingAgreement';
  agreementId: Maybe<Scalars['ID']['output']>;
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  created: Maybe<Scalars['Float']['output']>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<Array<Maybe<DataProcessingAgreementRepresentative>>>;
  signedAt: Maybe<Scalars['Float']['output']>;
  status: Maybe<DataProcessingAgreementStatus>;
  tosContent: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionCreated: Maybe<Scalars['Float']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
  updated: Maybe<Scalars['Float']['output']>;
};

export enum DataProcessingAgreementBusinessType {
  Company = 'COMPANY',
  Unregistered = 'UNREGISTERED',
}

export type DataProcessingAgreementDraft = {
  __typename?: 'DataProcessingAgreementDraft';
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<
    Array<Maybe<DataProcessingAgreementDraftRepresentative>>
  >;
};

export type DataProcessingAgreementDraftRepresentative = {
  __typename?: 'DataProcessingAgreementDraftRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type DataProcessingAgreementRepresentative = {
  __typename?: 'DataProcessingAgreementRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementRepresentativeInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DataProcessingAgreementSigningConfirmResult = {
  __typename?: 'DataProcessingAgreementSigningConfirmResult';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSigningStartResult = {
  __typename?: 'DataProcessingAgreementSigningStartResult';
  agreementId: Maybe<Scalars['ID']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSmsCodeInput = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum DataProcessingAgreementStatus {
  Pending = 'PENDING',
  Signed = 'SIGNED',
}

export type DataProcessingAgreementTosPreview = {
  __typename?: 'DataProcessingAgreementTosPreview';
  content: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
};

export enum DeadlineScenario {
  Deadline = 'Deadline',
  Timeout = 'Timeout',
  Unlimited = 'Unlimited',
}

export type DecorationField = {
  __typename?: 'DecorationField';
  decorationFieldId: Maybe<Scalars['ID']['output']>;
  types: Maybe<Array<Maybe<DecorationFieldType>>>;
};

export enum DecorationFieldType {
  Connector = 'Connector',
  Date = 'Date',
  FirstName = 'FirstName',
  FirstNameInitial = 'FirstNameInitial',
  SecondName = 'SecondName',
  SecondNameInitial = 'SecondNameInitial',
}

export type DecorationForClient = {
  __typename?: 'DecorationForClient';
  decorationForClientId: Maybe<Scalars['ID']['output']>;
  fields: Maybe<Array<Maybe<DecorationField>>>;
};

export type DecorationPreConfig = {
  __typename?: 'DecorationPreConfig';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DecorationPreConfigForClient = {
  __typename?: 'DecorationPreConfigForClient';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigForClientId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DecorationPreConfigInput = {
  connector: Scalars['String']['input'];
  date: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  secondName: Scalars['String']['input'];
};

export type DeleteTextSnippetResponse = {
  __typename?: 'DeleteTextSnippetResponse';
  supportSnippetId: Scalars['ID']['output'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  additional: Maybe<Scalars['String']['output']>;
  buildingNumber: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  deliveryAddressId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  flatNumber: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  context: Maybe<Array<Maybe<DeliveryMethodContext>>>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  easyPackOrgId: Maybe<Scalars['ID']['output']>;
  easyPackToken: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryMethodContext {
  EmbedStore = 'EmbedStore',
  Lab = 'Lab',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  Wedding = 'Wedding',
}

export type DeliveryMethodForDisplay = {
  __typename?: 'DeliveryMethodForDisplay';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  isAutoSell: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryType {
  Courier = 'Courier',
  Digital = 'Digital',
  EasyPack24 = 'EasyPack24',
  Pickup = 'Pickup',
}

export type DeviceLoggedOutEvent = {
  __typename?: 'DeviceLoggedOutEvent';
  deviceId: Scalars['ID']['output'];
  occurredAt: Scalars['Int']['output'];
};

export type DisableTwoFactorAuthenticatorResponse = {
  __typename?: 'DisableTwoFactorAuthenticatorResponse';
  errorCode: Maybe<TwoFactorAuthenticatorErrorCode>;
  status: Scalars['Boolean']['output'];
};

export type DuplicateSessionInput = {
  copyConsentsAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  copyMessages?: InputMaybe<Scalars['Boolean']['input']>;
  copyPhotoGroups?: InputMaybe<Scalars['Boolean']['input']>;
  copyPhotoGroupsConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  copyPromoCodes?: InputMaybe<Scalars['Boolean']['input']>;
  copySalesSettings?: InputMaybe<Scalars['Boolean']['input']>;
  mergeWithOriginal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileForUpload = {
  fileName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  originalHeight?: InputMaybe<Scalars['Int']['input']>;
  originalName: Scalars['String']['input'];
  originalWidth?: InputMaybe<Scalars['Int']['input']>;
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  photoId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FileForUploadByLocalClient = {
  fileName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  isRaw: Scalars['Boolean']['input'];
  originalName: Scalars['String']['input'];
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  photoId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FilePricing = {
  __typename?: 'FilePricing';
  filePricingId: Maybe<Scalars['String']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printsIncluded: Maybe<Array<Maybe<PrintsCount>>>;
  size: Maybe<Scalars['Int']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type FilePricingInput = {
  filePricingId: Scalars['String']['input'];
  isFull: Scalars['Boolean']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printsIncluded: Array<InputMaybe<UpdatePrintsCount>>;
  size: Scalars['Int']['input'];
  stepPricing: StepPricingInput;
  stepPricingEnabled: Scalars['Boolean']['input'];
};

export type FileWatermark = {
  __typename?: 'FileWatermark';
  fileName: Maybe<Scalars['ID']['output']>;
  fileWatermarkId: Maybe<Scalars['ID']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type FileWatermarkInput = {
  fileName: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum FilesAndPrintsPackageType {
  AnyImage = 'AnyImage',
  OneImage = 'OneImage',
  PickedImage = 'PickedImage',
}

export type FilesConfig = {
  __typename?: 'FilesConfig';
  count: Maybe<Scalars['Int']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type ForcedImageConfig = {
  __typename?: 'ForcedImageConfig';
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type ForcedImageConfigUpdate = {
  photoGroupId?: InputMaybe<Scalars['ID']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
};

export type FramesOrder = {
  __typename?: 'FramesOrder';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type FramesOrderInput = {
  black?: InputMaybe<Scalars['Int']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupImagesByPeopleType {
  FirstName = 'FirstName',
  FullName = 'FullName',
}

export enum GroupImagesByPeopleTypeForDisplay {
  FirstName = 'FirstName',
  FullName = 'FullName',
}

export type I18nText = {
  __typename?: 'I18nText';
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type I18nTextInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type IdentityPhotoMutationStatus = {
  __typename?: 'IdentityPhotoMutationStatus';
  session: Maybe<PublicSession>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type ImageContainer = {
  __typename?: 'ImageContainer';
  images: Maybe<ImageList>;
  imagesCount: Maybe<Scalars['Int']['output']>;
  label: Maybe<Array<Maybe<CustomLabel>>>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  type: Maybe<ImagesContainer>;
  typeId: Maybe<Scalars['ID']['output']>;
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type ImageList = {
  __typename?: 'ImageList';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  imageListId: Maybe<Scalars['ID']['output']>;
  imagesCount: Maybe<ImagesCount>;
  suggestions: Maybe<Array<Maybe<ImageSuggestion>>>;
};

export type ImageSuggestion = {
  __typename?: 'ImageSuggestion';
  comment: Maybe<Array<Maybe<CustomLabel>>>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export enum ImagesContainer {
  AlbumDesign = 'AlbumDesign',
  BookingPortfolio = 'BookingPortfolio',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  Wedding = 'Wedding',
}

export type ImagesCount = {
  __typename?: 'ImagesCount';
  all: Maybe<Scalars['Int']['output']>;
  hasPeople: Maybe<Scalars['Boolean']['output']>;
  imagesCountId: Maybe<Scalars['ID']['output']>;
  uploadInProgress: Maybe<Scalars['Int']['output']>;
};

export type InsertedImageList = {
  __typename?: 'InsertedImageList';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  id: Maybe<Scalars['String']['output']>;
  imagesCount: Maybe<ImagesCount>;
};

export type InsertedImageListByLocalClient = {
  __typename?: 'InsertedImageListByLocalClient';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  id: Maybe<Scalars['String']['output']>;
  imagesCount: Maybe<ImagesCount>;
  taskSet: Maybe<LocalClientTaskSet>;
  taskSetId: Maybe<Scalars['ID']['output']>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  buyerEmail: Maybe<Scalars['String']['output']>;
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyPostCode: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type LastVisitItem = {
  __typename?: 'LastVisitItem';
  id: Maybe<Scalars['ID']['output']>;
  type: Maybe<ZalamoObject>;
};

export type ListOfGroupsInSession = {
  __typename?: 'ListOfGroupsInSession';
  groups: Maybe<Array<Maybe<PublicSessionGroup>>>;
  id: Maybe<Scalars['ID']['output']>;
};

export type ListOfGroupsInSessionDisplay = {
  __typename?: 'ListOfGroupsInSessionDisplay';
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  id: Maybe<Scalars['ID']['output']>;
  watermarkCacheBomb: Maybe<Scalars['String']['output']>;
};

export type LocalClient = {
  __typename?: 'LocalClient';
  config: Maybe<LocalClientConfig>;
  created: Maybe<Scalars['Int']['output']>;
  ignored: Maybe<Scalars['Boolean']['output']>;
  localClientId: Maybe<Scalars['ID']['output']>;
  secret: Maybe<Scalars['String']['output']>;
};

export type LocalClientConfig = {
  __typename?: 'LocalClientConfig';
  exportDigital: Maybe<Scalars['Boolean']['output']>;
  exportOrders: Maybe<Scalars['Boolean']['output']>;
  exportPrints: Maybe<Scalars['Boolean']['output']>;
  exportProducts: Maybe<Scalars['Boolean']['output']>;
  localClientConfigId: Maybe<Scalars['ID']['output']>;
  ordersExportPath: Maybe<Scalars['String']['output']>;
};

export type LocalClientConfigInput = {
  exportOrders: Scalars['Boolean']['input'];
  ordersExportPath?: InputMaybe<Scalars['String']['input']>;
};

export type LocalClientSubTask = {
  __typename?: 'LocalClientSubTask';
  arguments: Maybe<Scalars['String']['output']>;
  failCount: Maybe<Scalars['Int']['output']>;
  localClientSubTaskId: Maybe<Scalars['ID']['output']>;
  source: Maybe<Scalars['String']['output']>;
  sourceId: Maybe<Scalars['ID']['output']>;
};

export enum LocalClientTaskContext {
  BookingPortfolio = 'BookingPortfolio',
  ChatAttachment = 'ChatAttachment',
  ConfigTemplate = 'ConfigTemplate',
  CoverPrivate = 'CoverPrivate',
  CoverPublic = 'CoverPublic',
  DecorationFile = 'DecorationFile',
  DigitalOrder = 'DigitalOrder',
  FileWatermark = 'FileWatermark',
  LookBookPreview = 'LookBookPreview',
  Model3D = 'Model3D',
  Order = 'Order',
  OrganizationLogo = 'OrganizationLogo',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  PrivateSessionPackage = 'PrivateSessionPackage',
  Product = 'Product',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionPackage = 'PublicSessionPackage',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  SupplierPrintsOrder = 'SupplierPrintsOrder',
  SupplierProductOrder = 'SupplierProductOrder',
  UserAvatar = 'UserAvatar',
}

export type LocalClientTaskSet = {
  __typename?: 'LocalClientTaskSet';
  allTasks: Maybe<Scalars['Int']['output']>;
  context: Maybe<LocalClientTaskContext>;
  contextId: Maybe<Scalars['ID']['output']>;
  dir: Maybe<Scalars['String']['output']>;
  failCount: Maybe<Scalars['Int']['output']>;
  localClientId: Maybe<Scalars['ID']['output']>;
  localClientTaskSetId: Maybe<Scalars['Int']['output']>;
  taskName: Maybe<LocalClientTaskType>;
  unDoneTasks: Maybe<Scalars['Int']['output']>;
};

export enum LocalClientTaskType {
  OrderExport = 'OrderExport',
  UploadFull = 'UploadFull',
  UploadThumb = 'UploadThumb',
}

export type LoginCheckResponse = {
  __typename?: 'LoginCheckResponse';
  availableAccounts: Maybe<Array<Maybe<UserType>>>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type LoginStatus = {
  __typename?: 'LoginStatus';
  loginValid: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
  twoFactorRequired: Maybe<Scalars['Boolean']['output']>;
};

export type LookBookDetailsForClient = {
  __typename?: 'LookBookDetailsForClient';
  configs: Maybe<Array<Maybe<LookBookProductConfig>>>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  labs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lookBookId: Maybe<Scalars['ID']['output']>;
  occasion: Maybe<LookBookOccasionForClient>;
  postOrderMessage: Maybe<Array<Maybe<CustomLabel>>>;
  spreadsCount: Maybe<Scalars['Int']['output']>;
  welcomeMessage: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookInBasketInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  countPhotos?: InputMaybe<LookBookProductImageLimitationInput>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  firstAddedFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  imageMap?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  lookBookProductConfigId?: InputMaybe<Scalars['ID']['input']>;
  lookBookProductId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  nameClientProduct?: InputMaybe<Scalars['String']['input']>;
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  photoIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  redBackground?: InputMaybe<Scalars['Boolean']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export enum LookBookOccasionForClient {
  ChildSession = 'ChildSession',
  CoupleAnniversary = 'CoupleAnniversary',
  FamilyEvent = 'FamilyEvent',
  FirstCommunion = 'FirstCommunion',
  OtherOccasion = 'OtherOccasion',
  Wedding = 'Wedding',
}

export enum LookBookPriceRounding {
  Five = 'Five',
  One = 'One',
  Ten = 'Ten',
}

export type LookBookProductColorDefinition = {
  __typename?: 'LookBookProductColorDefinition';
  colorId: Maybe<Scalars['ID']['output']>;
  label: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookProductConfig = {
  __typename?: 'LookBookProductConfig';
  config: Maybe<Scalars['String']['output']>;
  cost: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  count: Maybe<Scalars['Int']['output']>;
  created: Maybe<Scalars['Int']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  sent: Maybe<Scalars['Boolean']['output']>;
  sentWhen: Maybe<Scalars['Int']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
};

export type LookBookProductConfigUpdate = {
  config?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookProductImageLimitation = {
  __typename?: 'LookBookProductImageLimitation';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type LookBookProductImageLimitationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LookBookProductInBasket = {
  __typename?: 'LookBookProductInBasket';
  accessToken: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  countPhotos: Maybe<LookBookProductImageLimitation>;
  finished: Maybe<Scalars['Boolean']['output']>;
  firstAddedFile: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  imageMap: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  lookBookProductId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  nameClientProduct: Maybe<Scalars['String']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  photoIdList: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  quantity: Maybe<Scalars['Int']['output']>;
  redBackground: Maybe<Scalars['Boolean']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
  timeAddedToShoppingCart: Maybe<Scalars['Int']['output']>;
  valueMap: Maybe<Scalars['String']['output']>;
};

export type LookBookProductMaterialDefinition = {
  __typename?: 'LookBookProductMaterialDefinition';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  materialId: Maybe<Scalars['ID']['output']>;
};

export type MagnetForDisplay = {
  __typename?: 'MagnetForDisplay';
  magnetForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<MagnetSize>;
};

export enum MagnetSize {
  S6_67x10 = 's6_67x10',
  S10x15 = 's10x15',
}

export type MineStatus = {
  __typename?: 'MineStatus';
  mineStatusId: Maybe<Scalars['ID']['output']>;
  online: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPublicSessionOrganizationRole: Maybe<PublicSessionOrganizationRole>;
  beginTwoFactorAuthenticatorSetup: BeginTwoFactorAuthenticatorSetupResponse;
  changePhotographerSubdomain: Maybe<Scalars['Int']['output']>;
  clearSupportUserTestsCache: Scalars['Boolean']['output'];
  confirmTwoFactorAuthenticatorSetup: ConfirmTwoFactorAuthenticatorSetupResponse;
  createAutoLogin: Maybe<Scalars['String']['output']>;
  createOrGetTabloDemoSession: Maybe<Scalars['ID']['output']>;
  createSupportIssue: SupportIssue;
  createSupportIssueFromSupportThread: SupportIssue;
  createTextSnippet: TextSnippet;
  createUploadQueue: Maybe<UploadQueue>;
  deleteImages: Maybe<ImageList>;
  deletePaymentMethod: Maybe<Scalars['Boolean']['output']>;
  deleteTextSnippet: DeleteTextSnippetResponse;
  disableTwoFactorAuthenticator: DisableTwoFactorAuthenticatorResponse;
  duplicatePublicSession: Maybe<SessionDuplicationResult>;
  enablePhotoId: Maybe<IdentityPhotoMutationStatus>;
  exportSupportConversations: SupportConversationExportResult;
  finalizePhotographerRegistration: Maybe<RegisterPhotographerFinalizeResponse>;
  generateSupportThreadAiSuggestions: SupportThreadAiAnalysisStatus;
  importPublicSessionSignupChildren: PublicSessionSignupChildrenImportResult;
  increaseAntiAiPhotosCount: Maybe<MutationStatus>;
  increaseFreeDownloadAllCount: Maybe<MutationStatus>;
  insertComment: Maybe<Comment>;
  insertFiles: Maybe<InsertedImageList>;
  insertFilesByLocalClient: Maybe<InsertedImageListByLocalClient>;
  insertLastSeenForType: Maybe<Scalars['Boolean']['output']>;
  insertMessageFromSupport: Maybe<StandaloneSupportMessage>;
  insertPublicSession: Maybe<PublicSession>;
  insertPublicSessionChild: Maybe<PublicSessionChild>;
  insertPublicSessionChildBulk: Maybe<Array<Maybe<PublicSessionChild>>>;
  insertPublicSessionGroup: Maybe<PublicSessionGroup>;
  insertPublicSessionOrganization: Maybe<PublicSessionOrganization>;
  insertPublicSessionOrganizationContact: Maybe<PublicSessionOrganizationMember>;
  insertPublicSessionOrganizationGroup: Maybe<PublicSessionOrganizationGroup>;
  insertPublicSessionOrganizationMember: Maybe<PublicSessionOrganizationMember>;
  login: Maybe<LoginStatus>;
  logoutCurrentUser: Maybe<MutationStatus>;
  logoutDevice: Maybe<MutationStatus>;
  makrPhoneNumberAsVerified: Maybe<OldUserDetails>;
  markAllSupportIssueNotificationsRead: Scalars['Int']['output'];
  markCommentsThreadAsSeen: Maybe<UserHasConversation>;
  markProductAsBroken: Maybe<MutationStatus>;
  markProductAsProofed: Maybe<MutationStatus>;
  markSupportIssueNotificationRead: SupportIssueNotification;
  moveImages: Maybe<Array<Maybe<ImageList>>>;
  moveToPrivate: Maybe<MutationStatus2>;
  moveToPublic: Maybe<MutationStatus2>;
  prolongPublicSession: Maybe<MutationStatus>;
  refreshTabloProofingRender: Maybe<MutationStatus>;
  resetPassword: Maybe<PasswordCheckResponse>;
  restoreArchive: Maybe<Scalars['Int']['output']>;
  sendEmailToSchool: Maybe<Scalars['Boolean']['output']>;
  sendMailToSchool: Maybe<SchoolDetails>;
  sendPasswordResetEmail: Maybe<MutationStatus>;
  setImageSuggestion: Maybe<ImageSuggestion>;
  setPublicSessionPhotoPeople: PublicSessionPhotoPeopleAssignment;
  setSuggestionComment: Maybe<ImageSuggestion>;
  setSupportThreadAiSuggestionRating: SupportThreadAiSuggestion;
  startPhotographerRegistration: Maybe<RegisterPhotographerInitResponse>;
  updateFlyersInPublicSessionOrders: Maybe<MutationStatus>;
  updateInvoiceDetails: Maybe<OrganizationInvoiceDetails>;
  updateLastSeenComments: Maybe<UserHasConversation>;
  updateMineOnlineState: Maybe<MutationStatus>;
  updatePhoto: Maybe<PhotoUpdateResult>;
  updatePhotosSort: Maybe<MutationStatus2>;
  updatePublicSession: Maybe<PublicSession>;
  updatePublicSessionChild: Maybe<PublicSessionChild>;
  updatePublicSessionGroup: Maybe<PublicSessionGroup>;
  updatePublicSessionGroupSort: Maybe<MutationStatus>;
  updatePublicSessionOrganization: Maybe<PublicSessionOrganization>;
  updatePublicSessionOrganizationGroup: Maybe<PublicSessionOrganizationGroup>;
  updatePublicSessionOrganizationGroupMembers: Maybe<PublicSessionGroupMembersList>;
  updatePublicSessionOrganizationMember: Maybe<PublicSessionOrganizationMember>;
  updatePublicSessionOrganizationSettings: Maybe<PublicSessionOrganization>;
  updatePublicSessionProlongation: Maybe<Scalars['Boolean']['output']>;
  updateSchoolDetails: Maybe<SchoolDetails>;
  updateSupportIssue: SupportIssue;
  updateSupportOrganizationTests: SupportOrganizationTestsState;
  updateSupportUserTests: SupportUserTestsState;
  updateTextSnippet: TextSnippet;
  updateThread: Maybe<SupportRequest>;
  updateZalamoPrintSessionConfig: Maybe<ZalamoPrintSessionConfig>;
};

export type MutationAddPublicSessionOrganizationRoleArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
  publicSessionOrganizationRoleId: Scalars['ID']['input'];
  roleName: Scalars['String']['input'];
};

export type MutationBeginTwoFactorAuthenticatorSetupArgs = {
  password: Scalars['String']['input'];
};

export type MutationChangePhotographerSubdomainArgs = {
  newSubdomain: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
};

export type MutationClearSupportUserTestsCacheArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationConfirmTwoFactorAuthenticatorSetupArgs = {
  code: Scalars['String']['input'];
};

export type MutationCreateAutoLoginArgs = {
  type?: InputMaybe<UserType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateOrGetTabloDemoSessionArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateSupportIssueArgs = {
  input: CreateSupportIssueInput;
};

export type MutationCreateSupportIssueFromSupportThreadArgs = {
  input: CreateSupportIssueFromThreadInput;
  supportThreadId: Scalars['ID']['input'];
};

export type MutationCreateTextSnippetArgs = {
  content: Array<I18nTextInput>;
  supportSnippetId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type MutationCreateUploadQueueArgs = {
  photos?: InputMaybe<Array<InputMaybe<CreateUploadQueueFileInput>>>;
  queue?: InputMaybe<CreateUploadQueueInput>;
};

export type MutationDeleteImagesArgs = {
  context: ImagesContainer;
  contextId: Scalars['ID']['input'];
  images: Array<InputMaybe<Scalars['ID']['input']>>;
  photoGroupId: Scalars['ID']['input'];
};

export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationDeleteTextSnippetArgs = {
  supportSnippetId: Scalars['ID']['input'];
};

export type MutationDisableTwoFactorAuthenticatorArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationDuplicatePublicSessionArgs = {
  context?: InputMaybe<PublicSessionContext>;
  cover?: InputMaybe<CoverUpdateDetails>;
  duplicationDetails?: InputMaybe<DuplicateSessionInput>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  organizerGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  publicSessionId: Scalars['ID']['input'];
  shootDate?: InputMaybe<Scalars['Int']['input']>;
  sourcePublicSessionId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MutationEnablePhotoIdArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type MutationExportSupportConversationsArgs = {
  outputDir?: InputMaybe<Scalars['String']['input']>;
};

export type MutationFinalizePhotographerRegistrationArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type MutationGenerateSupportThreadAiSuggestionsArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type MutationImportPublicSessionSignupChildrenArgs = {
  children: Array<PublicSessionSignupChildImportInput>;
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type MutationIncreaseAntiAiPhotosCountArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  publicSessionId: Scalars['ID']['input'];
};

export type MutationIncreaseFreeDownloadAllCountArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type MutationInsertCommentArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentsListId: Scalars['ID']['input'];
  context: CommentContext;
  contextId: Scalars['ID']['input'];
  conversationMessageId: Scalars['ID']['input'];
  mentionedMembers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mentionedObjects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<CommnetType>;
};

export type MutationInsertFilesArgs = {
  context: UploadContext;
  contextId: Scalars['ID']['input'];
  photos?: InputMaybe<Array<InputMaybe<FileForUpload>>>;
  retouched: Scalars['Boolean']['input'];
  supplierPrintsImportConfig?: InputMaybe<SupplierPrintsImportConfig>;
};

export type MutationInsertFilesByLocalClientArgs = {
  context: UploadContext;
  contextId: Scalars['ID']['input'];
  localClientId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  photos?: InputMaybe<Array<InputMaybe<FileForUploadByLocalClient>>>;
  retouched: Scalars['Boolean']['input'];
  supplierPrintsImportConfig?: InputMaybe<SupplierPrintsImportConfig>;
};

export type MutationInsertLastSeenForTypeArgs = {
  object: ZalamoObject;
  objectId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationInsertMessageFromSupportArgs = {
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
  type: CommnetType;
};

export type MutationInsertPublicSessionArgs = {
  context?: InputMaybe<PublicSessionContext>;
  cover?: InputMaybe<CoverUpdateDetails>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  originalConfigTemplateId?: InputMaybe<Scalars['ID']['input']>;
  publicSessionId: Scalars['ID']['input'];
  publicSessionOrganizationGroupId?: InputMaybe<Scalars['String']['input']>;
  publicSessionOrganizationId?: InputMaybe<Scalars['String']['input']>;
  shootDate?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackedShootingId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationInsertPublicSessionChildArgs = {
  child: PublicSessionChildInput;
  publicSessionChildId: Scalars['ID']['input'];
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type MutationInsertPublicSessionChildBulkArgs = {
  children: Array<InputMaybe<PublicSessionChildBulkInput>>;
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type MutationInsertPublicSessionGroupArgs = {
  label?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  newPhotoGroupId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  publicSessionGroupId: Scalars['String']['input'];
  publicSessionId: Scalars['String']['input'];
};

export type MutationInsertPublicSessionOrganizationArgs = {
  isVirtual: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
  type: PublicSessionOrganizationType;
};

export type MutationInsertPublicSessionOrganizationContactArgs = {
  input?: InputMaybe<PublicSessionOrganizationMemberInput>;
  publicSessionOrganizationId: Scalars['ID']['input'];
  publicSessionOrganizationMemberId: Scalars['ID']['input'];
};

export type MutationInsertPublicSessionOrganizationGroupArgs = {
  name: Scalars['String']['input'];
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type MutationInsertPublicSessionOrganizationMemberArgs = {
  input?: InputMaybe<PublicSessionOrganizationMemberInput>;
  publicSessionOrganizationId: Scalars['ID']['input'];
  publicSessionOrganizationMemberId: Scalars['ID']['input'];
};

export type MutationLoginArgs = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  type?: InputMaybe<UserType>;
};

export type MutationLogoutDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationMakrPhoneNumberAsVerifiedArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationMarkCommentsThreadAsSeenArgs = {
  context: CommentContext;
  contextId: Scalars['ID']['input'];
};

export type MutationMarkProductAsBrokenArgs = {
  productForProofingId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationMarkProductAsProofedArgs = {
  productForProofingId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationMarkSupportIssueNotificationReadArgs = {
  notificationId: Scalars['ID']['input'];
};

export type MutationMoveImagesArgs = {
  from: Scalars['ID']['input'];
  images: Array<InputMaybe<Scalars['ID']['input']>>;
  to: Scalars['ID']['input'];
};

export type MutationMoveToPrivateArgs = {
  blob: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationMoveToPublicArgs = {
  blob: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationProlongPublicSessionArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type MutationRefreshTabloProofingRenderArgs = {
  productForProofingId: Scalars['ID']['input'];
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type MutationRestoreArchiveArgs = {
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendEmailToSchoolArgs = {
  schoolId: Scalars['ID']['input'];
};

export type MutationSendMailToSchoolArgs = {
  schoolId: Scalars['ID']['input'];
};

export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationSetImageSuggestionArgs = {
  context: ImagesContainer;
  contextId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};

export type MutationSetPublicSessionPhotoPeopleArgs = {
  people: Array<Scalars['ID']['input']>;
  photoId: Scalars['ID']['input'];
  publicSessionId: Scalars['ID']['input'];
};

export type MutationSetSuggestionCommentArgs = {
  comment?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  context: ImagesContainer;
  contextId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
};

export type MutationSetSupportThreadAiSuggestionRatingArgs = {
  rating: Scalars['Int']['input'];
  supportThreadAiSuggestionId: Scalars['ID']['input'];
};

export type MutationStartPhotographerRegistrationArgs = {
  input: RegisterPhotographerInput;
};

export type MutationUpdateFlyersInPublicSessionOrdersArgs = {
  promoFlyerId?: InputMaybe<Scalars['ID']['input']>;
  publicSessionId: Scalars['ID']['input'];
};

export type MutationUpdateInvoiceDetailsArgs = {
  organizationId: Scalars['ID']['input'];
  update: OrganizationInvoiceDetailsUpdate;
};

export type MutationUpdateLastSeenCommentsArgs = {
  lastSeenCommentDate: Scalars['Int']['input'];
  seenCommentsCount: Scalars['Int']['input'];
  userHasConversationId: Scalars['ID']['input'];
};

export type MutationUpdateMineOnlineStateArgs = {
  imOnline: Scalars['Boolean']['input'];
};

export type MutationUpdatePhotoArgs = {
  input: PhotoUpdate;
  photoId: Scalars['ID']['input'];
};

export type MutationUpdatePhotosSortArgs = {
  newSort: Array<InputMaybe<SortInput>>;
  photoGroupId: Scalars['ID']['input'];
};

export type MutationUpdatePublicSessionArgs = {
  publicSessionId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<PublicSesionUpdateInput>;
};

export type MutationUpdatePublicSessionChildArgs = {
  child: PublicSessionChildInput;
  publicSessionChildId: Scalars['ID']['input'];
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type MutationUpdatePublicSessionGroupArgs = {
  publicSessionGroupId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<PublicSessionGroupUpdateInput>;
};

export type MutationUpdatePublicSessionGroupSortArgs = {
  newOrder?: InputMaybe<Array<InputMaybe<PublicSessionSortInput>>>;
};

export type MutationUpdatePublicSessionOrganizationArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
  update?: InputMaybe<PublicSessionOrganizationUpdateInput>;
};

export type MutationUpdatePublicSessionOrganizationGroupArgs = {
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  update?: InputMaybe<PublicSessionOrganizationGroupUpdateInput>;
};

export type MutationUpdatePublicSessionOrganizationGroupMembersArgs = {
  members: Array<InputMaybe<Scalars['ID']['input']>>;
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
  roles: Array<InputMaybe<PublicSessionGroupMemberRoleInput>>;
};

export type MutationUpdatePublicSessionOrganizationMemberArgs = {
  input?: InputMaybe<PublicSessionOrganizationMemberInput>;
  publicSessionOrganizationMemberId: Scalars['ID']['input'];
};

export type MutationUpdatePublicSessionOrganizationSettingsArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
  settings?: InputMaybe<PublicSessionOrganizationSettingsUpdateInput>;
};

export type MutationUpdatePublicSessionProlongationArgs = {
  prolongation?: InputMaybe<Scalars['Int']['input']>;
  publicSessionId: Scalars['ID']['input'];
};

export type MutationUpdateSchoolDetailsArgs = {
  schoolDetails?: InputMaybe<SchoolDetailsInput>;
  schoolId: Scalars['ID']['input'];
};

export type MutationUpdateSupportIssueArgs = {
  input: UpdateSupportIssueInput;
  issueId: Scalars['ID']['input'];
};

export type MutationUpdateSupportOrganizationTestsArgs = {
  organizationId: Scalars['ID']['input'];
  tests: Array<OrganizationTest>;
};

export type MutationUpdateSupportUserTestsArgs = {
  tests: Array<UserTest>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateTextSnippetArgs = {
  content: Array<I18nTextInput>;
  supportSnippetId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type MutationUpdateThreadArgs = {
  supportThreadId: Scalars['ID']['input'];
  threadUpdateDetails: ThreadUpdateInput;
};

export type MutationUpdateZalamoPrintSessionConfigArgs = {
  input: ZalamoPrintSessionConfigInput;
  zalamoPrintSessionConfigId: Scalars['ID']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus2 = {
  __typename?: 'MutationStatus2';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NewZalamoOrderStats = {
  __typename?: 'NewZalamoOrderStats';
  days: Maybe<Array<Maybe<NewZalamoOrderStatsDay>>>;
  framesLastWeek: Maybe<Array<Maybe<NewZalamoOrderStatsDay>>>;
  months: Maybe<Array<Maybe<NewZalamoOrderStatsMonth>>>;
  topOrgsDaily: Maybe<Array<Maybe<NewZalamoStatsOrg>>>;
  topOrgsMonthly: Maybe<Array<Maybe<NewZalamoStatsOrg>>>;
  topOrgsWeekly: Maybe<Array<Maybe<NewZalamoStatsOrg>>>;
  topOrgsYearly: Maybe<Array<Maybe<NewZalamoStatsOrg>>>;
  wallDecor: Maybe<Array<Maybe<NewZalamoOrderStatsDay>>>;
};

export type NewZalamoOrderStatsDay = {
  __typename?: 'NewZalamoOrderStatsDay';
  context: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  orders: Maybe<Scalars['Int']['output']>;
  orgCount: Maybe<Scalars['Int']['output']>;
  productCount: Maybe<Scalars['Int']['output']>;
  revenue: Maybe<Scalars['Float']['output']>;
};

export type NewZalamoOrderStatsMonth = {
  __typename?: 'NewZalamoOrderStatsMonth';
  context: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  orders: Maybe<Scalars['Int']['output']>;
  orgCount: Maybe<Scalars['Int']['output']>;
  revenue: Maybe<Scalars['Float']['output']>;
};

export type NewZalamoProductUsageStats = {
  __typename?: 'NewZalamoProductUsageStats';
  count: Maybe<Scalars['Int']['output']>;
  month: Maybe<Scalars['String']['output']>;
  orgCount: Maybe<Scalars['Int']['output']>;
};

export type NewZalamoStats = {
  __typename?: 'NewZalamoStats';
  frames: Maybe<ZalamoFramesStats>;
  imagesPerformance: Maybe<Array<Maybe<ZalamoImagePerformance>>>;
  orders: Maybe<NewZalamoOrderStats>;
  usage: Maybe<NewZalamoUsageStats>;
  walldecor: Maybe<ZalamoFramesStats>;
  zalamoPay: Maybe<ZalamoPayStats>;
};

export type NewZalamoStatsOrg = {
  __typename?: 'NewZalamoStatsOrg';
  name: Maybe<Scalars['String']['output']>;
  ordersCount: Maybe<Scalars['Int']['output']>;
  revenue: Maybe<Scalars['Float']['output']>;
};

export type NewZalamoUsageStats = {
  __typename?: 'NewZalamoUsageStats';
  privateSessions: Maybe<Array<Maybe<NewZalamoProductUsageStats>>>;
  publicSessions: Maybe<Array<Maybe<NewZalamoProductUsageStats>>>;
};

export enum NiceUrlContainer {
  PublicSession = 'PublicSession',
}

export type NiceUrlValidationStatus = {
  __typename?: 'NiceUrlValidationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type OldSessionDetails = {
  __typename?: 'OldSessionDetails';
  created: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oldSessionDetailsId: Maybe<Scalars['ID']['output']>;
  photographer: Maybe<OldUser>;
};

export type OldUser = {
  __typename?: 'OldUser';
  lastSeen: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  type: Maybe<Array<Maybe<OldUserType>>>;
  userId: Maybe<Scalars['ID']['output']>;
};

export type OldUserDetails = {
  __typename?: 'OldUserDetails';
  clientSessionsCount: Maybe<Scalars['Int']['output']>;
  oldUserDetailsId: Maybe<Scalars['ID']['output']>;
  photographerAlbumDesignCount: Maybe<Scalars['Int']['output']>;
  photographerBookingsCount: Maybe<Scalars['Int']['output']>;
  photographerGalleryCount: Maybe<Scalars['Int']['output']>;
  photographerPrivateSessionsCount: Maybe<Scalars['Int']['output']>;
  photographerPublicSessionsCount: Maybe<Scalars['Int']['output']>;
  photographerWeddingCount: Maybe<Scalars['Int']['output']>;
  sessions: Maybe<Array<Maybe<OldSessionDetails>>>;
  type: Maybe<Array<Maybe<OldUserType>>>;
  verifiedPhone: Maybe<Scalars['Boolean']['output']>;
};

export enum OldUserType {
  Client = 'Client',
  Photographer = 'Photographer',
  Wedding = 'Wedding',
}

export type Organization = {
  __typename?: 'Organization';
  created: Maybe<Scalars['Int']['output']>;
  flags: Maybe<OrganizationMemberFlags>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  isPremiumLab: Maybe<Scalars['Boolean']['output']>;
  isSolo: Maybe<Scalars['Boolean']['output']>;
  isVatPayer: Maybe<Scalars['Boolean']['output']>;
  isZalamoMarketDigitalCreator: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  roles: Maybe<Array<Maybe<PermissionRole>>>;
  squareLogo: Maybe<Scalars['ID']['output']>;
  subdomain: Maybe<Scalars['String']['output']>;
  zalamoPayConfigFinished: Maybe<Scalars['Boolean']['output']>;
  zalamoPayRegisterInProgress: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationInvoiceDetails = {
  __typename?: 'OrganizationInvoiceDetails';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  organizationInvoiceDetailsId: Maybe<Scalars['ID']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceDetailsUpdate = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type OrganizationMemberFlags = {
  __typename?: 'OrganizationMemberFlags';
  hideOrders: Maybe<Scalars['Boolean']['output']>;
  hideRevenue: Maybe<Scalars['Boolean']['output']>;
};

export enum OrganizationResource {
  AlbumDesign = 'AlbumDesign',
  DigitalOrder = 'DigitalOrder',
  MemberManagement = 'MemberManagement',
  Orders = 'Orders',
  OrganizationDetails = 'OrganizationDetails',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  Products = 'Products',
  PublicSession = 'PublicSession',
  PublicSessions = 'PublicSessions',
  Wedding = 'Wedding',
  ZalamoRevenueReports = 'ZalamoRevenueReports',
}

export enum OrganizationTest {
  AntiAiWatermark = 'AntiAiWatermark',
  AutoSell = 'AutoSell',
  BigUpgrades = 'BigUpgrades',
  BookingLite = 'BookingLite',
  CampaignTrackedShootingCreation = 'CampaignTrackedShootingCreation',
  CountryPricePicker = 'CountryPricePicker',
  DeepTablo = 'DeepTablo',
  DidShop = 'DidShop',
  EmbedStore = 'EmbedStore',
  EmpikFoto = 'EmpikFoto',
  FilePricingAsSourceForPriceToAddToEveryFileInProduct = 'FilePricingAsSourceForPriceToAddToEveryFileInProduct',
  IdentityPhotoSell = 'IdentityPhotoSell',
  KrukBook = 'KrukBook',
  Notifications = 'Notifications',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  PermissionsCollection = 'PermissionsCollection',
  PrintOwnPhotos = 'PrintOwnPhotos',
  PrivateSession = 'PrivateSession',
  PrivateSessionLookBook = 'PrivateSessionLookBook',
  PublicSessionSignupCampaigns = 'PublicSessionSignupCampaigns',
  PublicSessionTemplates = 'PublicSessionTemplates',
  ScreenAppProtection = 'ScreenAppProtection',
  ScreenAppProtectionn = 'ScreenAppProtectionn',
  SellTriplex = 'SellTriplex',
  SellZalamoFrames = 'SellZalamoFrames',
  SnapPremiumPackage = 'SnapPremiumPackage',
  TabloDesigner = 'TabloDesigner',
  TestPremiumLab = 'TestPremiumLab',
  VisualGuides = 'VisualGuides',
  ZalamoPrintExperience = 'ZalamoPrintExperience',
  Csv = 'csv',
}

export enum P24Group {
  Another = 'Another',
  Blik = 'Blik',
  Card = 'Card',
  Credit = 'Credit',
  FastTransfers = 'FastTransfers',
  Foreign = 'Foreign',
  Installments = 'Installments',
  PrePayment = 'PrePayment',
  Prepayment = 'Prepayment',
  SplitPayment = 'SplitPayment',
  TraditionalTransfer = 'TraditionalTransfer',
  Wallet = 'Wallet',
  ETransfer = 'eTransfer',
}

export type P24PaymentMethod = {
  __typename?: 'P24PaymentMethod';
  group: Maybe<P24Group>;
  id: Maybe<Scalars['Int']['output']>;
  imgUrl: Maybe<Scalars['String']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  mobileImgUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  subgroup: Maybe<P24Group>;
};

export type PasswordCheckResponse = {
  __typename?: 'PasswordCheckResponse';
  firstName: Maybe<Scalars['String']['output']>;
  has2fa: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
  twoFactorChallengeId: Maybe<Scalars['ID']['output']>;
  twoFactorMethod: Maybe<TwoFactorMethod>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  name: Maybe<Scalars['String']['output']>;
  paymentMethodId: Maybe<Scalars['ID']['output']>;
};

export enum Permission {
  Insert = 'Insert',
  Read = 'Read',
  ShowPrices = 'ShowPrices',
  Update = 'Update',
}

export enum PermissionRole {
  Admin = 'Admin',
  CampaignManager = 'CampaignManager',
  LabEmployee = 'LabEmployee',
  LabManager = 'LabManager',
  LabOutsource = 'LabOutsource',
  OrdersManager = 'OrdersManager',
  Photographer = 'Photographer',
  RetouchManager = 'RetouchManager',
  Retoucher = 'Retoucher',
  Support = 'Support',
}

export type PersonForPublicSession = {
  __typename?: 'PersonForPublicSession';
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type PersonToPhotoRelation = {
  __typename?: 'PersonToPhotoRelation';
  people: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  personToPhotoRelationId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type Photo = {
  __typename?: 'Photo';
  fileName: Maybe<Scalars['String']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoInGroup = {
  __typename?: 'PhotoInGroup';
  order: Maybe<Scalars['Int']['output']>;
  photo: Maybe<SinglePhoto>;
  photoInGroupId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoUpdate = {
  height?: InputMaybe<Scalars['Int']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  originalHeight?: InputMaybe<Scalars['Int']['input']>;
  originalWidth?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoUpdateResult = {
  __typename?: 'PhotoUpdateResult';
  photo: Maybe<SinglePhoto>;
  photosInGroups: Maybe<Array<Maybe<PhotoInGroup>>>;
};

export type PhotoWithPeople = {
  __typename?: 'PhotoWithPeople';
  people: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccount = {
  __typename?: 'PhotographerAccount';
  invoiceDetails: Maybe<OrganizationInvoiceDetails>;
  organization: Maybe<Organization>;
  photographerId: Maybe<Scalars['ID']['output']>;
  timeZone: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccountDetails = {
  __typename?: 'PhotographerAccountDetails';
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  privateAddress: Maybe<Scalars['String']['output']>;
  privateCity: Maybe<Scalars['String']['output']>;
  privateCountry: Maybe<Scalars['String']['output']>;
  privateZipCode: Maybe<Scalars['String']['output']>;
};

export type PhotographerAccountDevice = {
  __typename?: 'PhotographerAccountDevice';
  deviceId: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['Int']['output']>;
};

export type PhotographerMobileNotificationsPairingToken = {
  __typename?: 'PhotographerMobileNotificationsPairingToken';
  expiresAt: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
};

export type PriceConfig = {
  __typename?: 'PriceConfig';
  code: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
};

export type PriceConfigInput = {
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};

export type PriceListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  list?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
};

export type PriceStep = {
  __typename?: 'PriceStep';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  step: Maybe<Scalars['Int']['output']>;
};

export type PriceStepInput = {
  price: Array<InputMaybe<PriceConfigInput>>;
  step: Scalars['Int']['input'];
};

export type PrintAndFileConfig = {
  __typename?: 'PrintAndFileConfig';
  filesConfig: Maybe<Array<Maybe<FilesConfig>>>;
  forcedImage: Maybe<ForcedImageConfig>;
  groups: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode: Maybe<FilesAndPrintsPackageType>;
  printAndFileConfigId: Maybe<Scalars['ID']['output']>;
  printsCount: Maybe<Array<Maybe<PrintsCount>>>;
};

export type PrintFormat = {
  __typename?: 'PrintFormat';
  label: Maybe<Scalars['String']['output']>;
  printFormatId: Maybe<Scalars['ID']['output']>;
};

export type PrintFrameInBasket = {
  __typename?: 'PrintFrameInBasket';
  count: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printFrameId: Maybe<Scalars['ID']['output']>;
  ratio: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type PrintFrameInBasketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  printFrameId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPaper = {
  __typename?: 'PrintPaper';
  label: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
};

export type PrintPriceConfig = {
  __typename?: 'PrintPriceConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsConfig = {
  __typename?: 'PrintsConfig';
  formats: Maybe<Array<Maybe<PrintFormat>>>;
  papers: Maybe<Array<Maybe<PrintPaper>>>;
};

export type PrintsCount = {
  __typename?: 'PrintsCount';
  count: Maybe<Scalars['Int']['output']>;
  printFormatId: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['String']['output']>;
};

export enum PrintsPricingContext {
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  PublicSessionGroup = 'PublicSessionGroup',
  WeddingCouple = 'WeddingCouple',
  WeddingGallery = 'WeddingGallery',
}

export type PrintsPricingList = {
  __typename?: 'PrintsPricingList';
  context: Maybe<PrintsPricingContext>;
  label: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsPricingListForDisplay = {
  __typename?: 'PrintsPricingListForDisplay';
  list: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListForDisplayId: Maybe<Scalars['ID']['output']>;
};

export type Product = {
  __typename?: 'Product';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasTaxConfig: Maybe<Scalars['Boolean']['output']>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxConfig: Maybe<ProductTaxConfig>;
  type: Maybe<ProductType>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  config: Maybe<Scalars['String']['output']>;
  customName: Maybe<Array<Maybe<CustomLabel>>>;
  icon: Maybe<Scalars['String']['output']>;
  mode: Maybe<ProductMode>;
  productId: Maybe<Scalars['String']['output']>;
  productInPackageId: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Int']['output']>;
};

export type ProductForDisplay = {
  __typename?: 'ProductForDisplay';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<ProductType>;
};

export type ProductForProofing = {
  __typename?: 'ProductForProofing';
  pages: Maybe<Array<Maybe<ProductForProofingPage>>>;
  pagesCount: Maybe<Scalars['Int']['output']>;
  productForProofingId: Maybe<Scalars['ID']['output']>;
  productForProofingType: Maybe<ProductForProofingType>;
  sourceProductInOrderId: Maybe<Scalars['ID']['output']>;
  sourceProjectId: Maybe<Scalars['ID']['output']>;
  sourceProjectUserId: Maybe<Scalars['ID']['output']>;
};

export type ProductForProofingPage = {
  __typename?: 'ProductForProofingPage';
  blobClip: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  blobName: Maybe<Scalars['String']['output']>;
  blobRotation: Maybe<Scalars['Float']['output']>;
  blobTargetPosition: Maybe<ProofingPosition>;
  blobTargetSize: Maybe<ProofingSize>;
  canvasTargetSize: Maybe<ProofingSize>;
  label: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  pageId: Maybe<Scalars['ID']['output']>;
  sourcePhotoId: Maybe<Scalars['ID']['output']>;
  tabloProjectId: Maybe<Scalars['ID']['output']>;
};

export enum ProductForProofingType {
  MagnetSticker = 'MagnetSticker',
  Tablo = 'Tablo',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoMagnet = 'ZalamoMagnet',
}

export enum ProductMode {
  AllImagesFromPackage = 'AllImagesFromPackage',
  AnyImages = 'AnyImages',
  AnyImagesFromPackage = 'AnyImagesFromPackage',
}

export type ProductPackage = {
  __typename?: 'ProductPackage';
  allowMultiple: Maybe<Scalars['Boolean']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printAndFileConfig: Maybe<Array<Maybe<PrintAndFileConfig>>>;
  productConfig: Maybe<Array<Maybe<ProductConfig>>>;
  productPackageId: Maybe<Scalars['ID']['output']>;
};

export type ProductTaxConfig = {
  __typename?: 'ProductTaxConfig';
  label: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type ProductTaxConfigInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductToProductRelation = {
  __typename?: 'ProductToProductRelation';
  id: Maybe<Scalars['String']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductToProductRelationType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum ProductToProductRelationType {
  Attribute = 'Attribute',
  Lab = 'Lab',
  Option = 'Option',
  Product = 'Product',
}

export enum ProductType {
  Album = 'Album',
  AlbumSet2plusOne = 'AlbumSet2plusOne',
  AlbumSetTriple = 'AlbumSetTriple',
  AlbumWithAcrylicPicture = 'AlbumWithAcrylicPicture',
  Book = 'Book',
  Calendar = 'Calendar',
  Canvas = 'Canvas',
  EconomicTwoPageTablo = 'EconomicTwoPageTablo',
  FatPrint = 'FatPrint',
  Frame = 'Frame',
  IdentityPhoto = 'IdentityPhoto',
  MagnetSticker = 'MagnetSticker',
  Mug = 'Mug',
  Other = 'Other',
  Prints = 'Prints',
  Tablo = 'Tablo',
  Tambour = 'Tambour',
  Triplex = 'Triplex',
  Wallart = 'Wallart',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoEconomicTwoPageTablo = 'ZalamoEconomicTwoPageTablo',
  ZalamoMagnet = 'ZalamoMagnet',
  ZalamoPremiumTwoPageTablo = 'ZalamoPremiumTwoPageTablo',
}

export type ProofingPosition = {
  __typename?: 'ProofingPosition';
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type ProofingSize = {
  __typename?: 'ProofingSize';
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type ProtectionWatermarkConfig = {
  __typename?: 'ProtectionWatermarkConfig';
  aiLevel: Maybe<Scalars['String']['output']>;
  customConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  fileName: Maybe<Scalars['ID']['output']>;
  linesOpacity: Maybe<Scalars['Float']['output']>;
  mode: ProtectionWatermarkMode;
  showLines: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<ProtectionWatermarkSource>;
  text: Maybe<Array<Maybe<CustomLabel>>>;
  textOpacity: Maybe<Scalars['Float']['output']>;
};

export type ProtectionWatermarkConfigInput = {
  aiLevel?: InputMaybe<Scalars['String']['input']>;
  customConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  fileName: Scalars['ID']['input'];
  linesOpacity: Scalars['Float']['input'];
  mode: ProtectionWatermarkMode;
  showLines: Scalars['Boolean']['input'];
  source: ProtectionWatermarkSource;
  text: Array<InputMaybe<CustomLabelInput>>;
  textOpacity: Scalars['Float']['input'];
};

export enum ProtectionWatermarkMode {
  Custom = 'Custom',
  Multi = 'Multi',
  Single = 'Single',
}

export enum ProtectionWatermarkSource {
  AntiAi = 'AntiAi',
  Image = 'Image',
  Text = 'Text',
}

export type PublicSesionUpdateInput = {
  acceptOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  addPrintFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addToFirstPrintPrice?: InputMaybe<Scalars['Boolean']['input']>;
  authMode?: InputMaybe<PublicSessionAuthMode>;
  autoSellConfig?: InputMaybe<AutoSellConfigInput>;
  autoSellEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientPermissionsConfig?: InputMaybe<Scalars['String']['input']>;
  configTemplateId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<PublicSessionContext>;
  cover?: InputMaybe<CoverUpdateDetails>;
  customDigitalFileName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  deadline?: InputMaybe<Scalars['Int']['input']>;
  deadlineScenario?: InputMaybe<DeadlineScenario>;
  deliveryMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  digitalOrderForcePhone?: InputMaybe<Scalars['Boolean']['input']>;
  disableImageZoom?: InputMaybe<Scalars['Boolean']['input']>;
  doNotAddPriceOfFirstPrint?: InputMaybe<Scalars['Boolean']['input']>;
  eSkarbonkaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enableFreeThumb?: InputMaybe<Scalars['Boolean']['input']>;
  enableKeywordSearch?: InputMaybe<Scalars['Boolean']['input']>;
  enableMinimalOrderValue?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePricing?: InputMaybe<Array<InputMaybe<FilePricingInput>>>;
  forceDisableFilesSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisablePrintsSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisableProductsSales?: InputMaybe<Scalars['Boolean']['input']>;
  freeDownloadAllAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  freePackageId?: InputMaybe<Scalars['ID']['input']>;
  freeThumbSize?: InputMaybe<Scalars['Int']['input']>;
  freeThumbWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  groupImagesByPeople?: InputMaybe<Scalars['Boolean']['input']>;
  groupImagesByPeopleType?: InputMaybe<GroupImagesByPeopleType>;
  inAppOnly?: InputMaybe<Scalars['Boolean']['input']>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isZalamoPrintEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lookBookConfig?: InputMaybe<SessionLookBookConfigInput>;
  lookBookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxImageSize?: InputMaybe<Scalars['Int']['input']>;
  maxImageSizeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<InputMaybe<PublicSessionMessageInput>>>;
  minimalOrderValue?: InputMaybe<Array<PriceConfigInput>>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  niceUrl?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizerGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  ownPhotosPrintPricingId?: InputMaybe<Scalars['ID']['input']>;
  packages?: InputMaybe<Array<InputMaybe<UpdateProductPackage>>>;
  password?: InputMaybe<Scalars['String']['input']>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  priceToAddToFirstPrint?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printOwnPhotosEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  printsPricingListId?: InputMaybe<Scalars['ID']['input']>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoPrintFlyerId?: InputMaybe<Scalars['ID']['input']>;
  retouchLevels?: InputMaybe<Array<InputMaybe<RetouchLevelInput>>>;
  retouchLevelsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sellFiles?: InputMaybe<Scalars['Boolean']['input']>;
  sellPackages?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrints?: InputMaybe<Scalars['Boolean']['input']>;
  sellProducts?: InputMaybe<Scalars['Boolean']['input']>;
  shootDate?: InputMaybe<Scalars['Int']['input']>;
  showFileNames?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  skipAddToFirstPrintIfFileBought?: InputMaybe<Scalars['Boolean']['input']>;
  soldFilesWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  soldFilesWatermarked?: InputMaybe<Scalars['Boolean']['input']>;
  soldWatermarkSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tosId?: InputMaybe<Scalars['ID']['input']>;
  useCustomDigitalFileName?: InputMaybe<Scalars['Boolean']['input']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  usePromoCodes?: InputMaybe<Scalars['Boolean']['input']>;
  visualPersonalization?: InputMaybe<Scalars['String']['input']>;
  watermarkConfig?: InputMaybe<ProtectionWatermarkConfigInput>;
  watermarkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublicSession = {
  __typename?: 'PublicSession';
  acceptOnlinePayments: Maybe<Scalars['Boolean']['output']>;
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  antiAiPaidPhotos: Maybe<Scalars['Int']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  autoSellConfig: Maybe<AutoSellConfig>;
  autoSellEnabled: Maybe<Scalars['Boolean']['output']>;
  availableFullDownloads: Maybe<Scalars['Int']['output']>;
  clientPermissionsConfig: Maybe<Scalars['String']['output']>;
  configTemplateId: Maybe<Scalars['ID']['output']>;
  context: Maybe<PublicSessionContext>;
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  customDigitalFileName: Maybe<Array<Maybe<CustomLabel>>>;
  deadline: Maybe<Scalars['Int']['output']>;
  deadlineScenario: Maybe<DeadlineScenario>;
  deliveryMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  digitalOrderForcePhone: Maybe<Scalars['Boolean']['output']>;
  disableImageZoom: Maybe<Scalars['Boolean']['output']>;
  doNotAddPriceOfFirstPrint: Maybe<Scalars['Boolean']['output']>;
  duplicateOf: Maybe<Scalars['String']['output']>;
  duplicatesCount: Maybe<Scalars['Int']['output']>;
  eSkarbonkaEnabled: Maybe<Scalars['Boolean']['output']>;
  enableFreeThumb: Maybe<Scalars['Boolean']['output']>;
  enableKeywordSearch: Maybe<Scalars['Boolean']['output']>;
  enableMinimalOrderValue: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  forceDisableFilesSales: Maybe<Scalars['Boolean']['output']>;
  forceDisablePrintsSales: Maybe<Scalars['Boolean']['output']>;
  forceDisableProductsSales: Maybe<Scalars['Boolean']['output']>;
  freeDownloadAllAvailable: Maybe<Scalars['Boolean']['output']>;
  freePackageId: Maybe<Scalars['ID']['output']>;
  freeThumbSize: Maybe<Scalars['Int']['output']>;
  freeThumbWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  groupImagesByPeople: Maybe<Scalars['Boolean']['output']>;
  groupImagesByPeopleType: Maybe<GroupImagesByPeopleType>;
  groups: Maybe<Array<Maybe<PublicSessionGroup>>>;
  inAppOnly: Maybe<Scalars['Boolean']['output']>;
  internalCode: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isIdentityPhotoPaid: Maybe<Scalars['Boolean']['output']>;
  isZalamoPrintEnabled: Maybe<Scalars['Boolean']['output']>;
  linkHash: Maybe<Scalars['ID']['output']>;
  lookBookConfig: Maybe<SessionLookBookConfig>;
  lookBookEnabled: Maybe<Scalars['Boolean']['output']>;
  maxImageSize: Maybe<Scalars['Int']['output']>;
  maxImageSizeEnabled: Maybe<Scalars['Boolean']['output']>;
  messages: Maybe<Array<Maybe<PublicSessionMessage>>>;
  minimalOrderValue: Maybe<Array<Maybe<PriceConfig>>>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  niceUrl: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  organizerGroupId: Maybe<Scalars['ID']['output']>;
  organizerOrganizationId: Maybe<Scalars['ID']['output']>;
  originalConfigTemplateId: Maybe<Scalars['ID']['output']>;
  ownPhotosPrintPricingId: Maybe<Scalars['ID']['output']>;
  packages: Maybe<Array<Maybe<ProductPackage>>>;
  password: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printOwnPhotosEnabled: Maybe<Scalars['Boolean']['output']>;
  printsPricing: Maybe<PrintsPricingList>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promoPrintFlyerId: Maybe<Scalars['ID']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  publicSessionSignupCampaignId: Maybe<Scalars['ID']['output']>;
  publishDate: Maybe<Scalars['Int']['output']>;
  retouchLevels: Maybe<Array<Maybe<RetouchLevel>>>;
  retouchLevelsEnabled: Maybe<Scalars['Boolean']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPackages: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  shootDate: Maybe<Scalars['Int']['output']>;
  showFileNames: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  soldFilesWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  soldFilesWatermarked: Maybe<Scalars['Boolean']['output']>;
  soldWatermarkSize: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  trackedShootingId: Maybe<Scalars['ID']['output']>;
  unlockedUntil: Maybe<Scalars['Int']['output']>;
  useCustomDigitalFileName: Maybe<Scalars['Boolean']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  usePromoCodes: Maybe<Scalars['Boolean']['output']>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
  watermarkConfig: Maybe<ProtectionWatermarkConfig>;
  watermarkEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PublicSessionAuthDetails = {
  __typename?: 'PublicSessionAuthDetails';
  PublicSessionAuthDetailsId: Maybe<Scalars['ID']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  deadline: Maybe<Scalars['Int']['output']>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  inAppOnly: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  personAccessRequired: Scalars['Boolean']['output'];
  squareLogo: Maybe<Scalars['ID']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export enum PublicSessionAuthMode {
  NoAuth = 'NoAuth',
  Password = 'Password',
}

export type PublicSessionChild = {
  __typename?: 'PublicSessionChild';
  createdSource: PublicSessionChildCreatedSource;
  deleted: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  photoId: Maybe<Scalars['String']['output']>;
  photoIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  publicSessionChildId: Scalars['ID']['output'];
  signupAssignment: Maybe<PublicSessionChildSignupAssignment>;
};

export type PublicSessionChildBulkInput = {
  createdSource?: InputMaybe<PublicSessionChildCreatedSource>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publicSessionChildId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PublicSessionChildCreatedSource {
  LegacyUnknown = 'LEGACY_UNKNOWN',
  Photographer = 'PHOTOGRAPHER',
  Signup = 'SIGNUP',
}

export type PublicSessionChildInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
};

export type PublicSessionChildSignupAssignment = {
  __typename?: 'PublicSessionChildSignupAssignment';
  confidenceScore: Maybe<Scalars['Float']['output']>;
  method: PublicSessionChildSignupAssignmentMethod;
  sourceCount: Scalars['Int']['output'];
  status: PublicSessionChildSignupAssignmentStatus;
  updatedAt: Scalars['Int']['output'];
};

export enum PublicSessionChildSignupAssignmentMethod {
  AutoCreated = 'AUTO_CREATED',
  AutoLinked = 'AUTO_LINKED',
  ManualConfirmed = 'MANUAL_CONFIRMED',
}

export enum PublicSessionChildSignupAssignmentStatus {
  Confirmed = 'CONFIRMED',
  NeedsReview = 'NEEDS_REVIEW',
}

export type PublicSessionChildrenList = {
  __typename?: 'PublicSessionChildrenList';
  children: Maybe<Array<Maybe<PublicSessionChild>>>;
  publicSessionOrganizationGroupId: Maybe<Scalars['ID']['output']>;
};

export enum PublicSessionContext {
  CompanyEvent = 'CompanyEvent',
  CompetitionBasketball = 'CompetitionBasketball',
  CompetitionBikeRiding = 'CompetitionBikeRiding',
  CompetitionCarRace = 'CompetitionCarRace',
  CompetitionDance = 'CompetitionDance',
  CompetitionFootball = 'CompetitionFootball',
  CompetitionHorseRiding = 'CompetitionHorseRiding',
  CompetitionMotoBike = 'CompetitionMotoBike',
  CompetitionRunning = 'CompetitionRunning',
  KindergartenSession = 'KindergartenSession',
  None = 'None',
  Prom = 'Prom',
  ReligionEventBaptism = 'ReligionEventBaptism',
  ReligionEventFirstCommunion = 'ReligionEventFirstCommunion',
  ReligionEventWedding = 'ReligionEventWedding',
  SchoolSession = 'SchoolSession',
  ShowCats = 'ShowCats',
  ShowDogs = 'ShowDogs',
  ShowHorses = 'ShowHorses',
}

export type PublicSessionEvent = {
  __typename?: 'PublicSessionEvent';
  deviceId: Maybe<Scalars['ID']['output']>;
  pageViewId: Maybe<Scalars['ID']['output']>;
  payload: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['Float']['output']>;
  type: Maybe<PublicSessionEventType>;
  visitId: Maybe<Scalars['ID']['output']>;
};

export enum PublicSessionEventType {
  PageVisitEnd = 'PageVisitEnd',
  PageVisitStart = 'PageVisitStart',
  PhotoView = 'PhotoView',
}

export type PublicSessionExcerpt = {
  __typename?: 'PublicSessionExcerpt';
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type PublicSessionForDisplay = {
  __typename?: 'PublicSessionForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  autoSellConfig: Maybe<AutoSellConfig>;
  autoSellEnabled: Maybe<Scalars['Boolean']['output']>;
  availableProducts: Maybe<Array<Maybe<ProductForDisplay>>>;
  calendarPrices: Maybe<Array<Maybe<CalendarForDisplay>>>;
  clientPermissionsConfig: Maybe<Scalars['String']['output']>;
  context: Maybe<PublicSessionContext>;
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  customDigitalFileName: Maybe<Array<Maybe<CustomLabel>>>;
  deliveryMethods: Maybe<Array<Maybe<DeliveryMethodForDisplay>>>;
  digitalOrderForcePhone: Maybe<Scalars['Boolean']['output']>;
  disableImageZoom: Maybe<Scalars['Boolean']['output']>;
  doNotAddPriceOfFirstPrint: Maybe<Scalars['Boolean']['output']>;
  eSkarbonka: Maybe<PublicSessionOrganizationEskarbonkaProgress>;
  enableFreeThumb: Maybe<Scalars['Boolean']['output']>;
  enableKeywordSearch: Maybe<Scalars['Boolean']['output']>;
  enableMinimalOrderValue: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  frame: Maybe<Product>;
  freeDownloadAllAvailable: Maybe<Scalars['Boolean']['output']>;
  freeDownloadAvailable: Maybe<Scalars['Boolean']['output']>;
  freePackageId: Maybe<Scalars['ID']['output']>;
  freeThumbSize: Maybe<Scalars['Int']['output']>;
  groupImagesByPeople: Maybe<Scalars['Boolean']['output']>;
  groupImagesByPeopleType: Maybe<GroupImagesByPeopleTypeForDisplay>;
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  invoicingEnabled: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  lookBookConfig: Maybe<SessionLookBookConfigForDisplay>;
  lookBookEnabled: Maybe<Scalars['Boolean']['output']>;
  magnetPrices: Maybe<Array<Maybe<MagnetForDisplay>>>;
  messages: Maybe<Array<Maybe<PublicSessionMessage>>>;
  minimalOrderValue: Maybe<Array<Maybe<PriceConfig>>>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  ownPrintsPricing: Maybe<PrintsPricingListForDisplay>;
  packages: Maybe<Array<Maybe<ProductPackage>>>;
  people: Maybe<Array<Maybe<PersonForPublicSession>>>;
  picturesWithPeople: Maybe<Array<Maybe<PhotoWithPeople>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printOwnPhotosEnabled: Maybe<Scalars['Boolean']['output']>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promoPrintFlyerId: Maybe<Scalars['ID']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  retouchLevels: Maybe<Array<Maybe<RetouchLevel>>>;
  retouchLevelsEnabled: Maybe<Scalars['Boolean']['output']>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellPackages: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  showFileNames: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  squareLogo: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  tabloList: Maybe<Array<Maybe<TabloForDisplay>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  useCustomDigitalFileName: Maybe<Scalars['Boolean']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  usePromoCodes: Maybe<Scalars['Boolean']['output']>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
};

export type PublicSessionGroup = {
  __typename?: 'PublicSessionGroup';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  additionalFolderSettings: Maybe<Scalars['String']['output']>;
  customFilesPricing: Maybe<Scalars['Boolean']['output']>;
  customPrintsPricing: Maybe<Scalars['Boolean']['output']>;
  customProductsConfig: Maybe<Scalars['Boolean']['output']>;
  customWatermark: Maybe<Scalars['Boolean']['output']>;
  disableLookBook: Maybe<Scalars['Boolean']['output']>;
  disableZalamoPrint: Maybe<Scalars['Boolean']['output']>;
  duplicateOf: Maybe<Scalars['String']['output']>;
  duplicatesCount: Maybe<Scalars['Int']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  hiddenForClient: Maybe<Scalars['Boolean']['output']>;
  identityPhotoPaperId: Maybe<Scalars['ID']['output']>;
  identityPhotoPassDigital: Maybe<Scalars['Boolean']['output']>;
  imagesCount: Maybe<ImagesCount>;
  individualSellSettings: Maybe<Scalars['Boolean']['output']>;
  isIdentityPhotoOnly: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  order: Maybe<Scalars['Int']['output']>;
  photoGroupId: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publicSessionGroupId: Maybe<Scalars['String']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  soldFilesWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  soldFilesWatermarked: Maybe<Scalars['Boolean']['output']>;
  soldWatermarkSize: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  watermarkConfig: Maybe<ProtectionWatermarkConfig>;
};

export type PublicSessionGroupForDisplay = {
  __typename?: 'PublicSessionGroupForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  customFilesPricing: Maybe<Scalars['Boolean']['output']>;
  customPrintsPricing: Maybe<Scalars['Boolean']['output']>;
  customProductsConfig: Maybe<Scalars['Boolean']['output']>;
  disableLookBook: Maybe<Scalars['Boolean']['output']>;
  disableZalamoPrint: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  identityPhotoPaperId: Maybe<Scalars['ID']['output']>;
  identityPhotoPassDigital: Maybe<Scalars['Boolean']['output']>;
  images: Maybe<Array<Maybe<ImageForDisplay>>>;
  individualSellSettings: Maybe<Scalars['Boolean']['output']>;
  isIdentityPhotoOnly: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  order: Maybe<Scalars['Int']['output']>;
  photoGroupId: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publicSessionGroupId: Maybe<Scalars['String']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
};

export type PublicSessionGroupMemberRole = {
  __typename?: 'PublicSessionGroupMemberRole';
  publicSessionGroupMemberId: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationRoleId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionGroupMemberRoleInput = {
  publicSessionGroupMemberId?: InputMaybe<Scalars['ID']['input']>;
  publicSessionOrganizationRoleId?: InputMaybe<Scalars['ID']['input']>;
};

export type PublicSessionGroupMembersList = {
  __typename?: 'PublicSessionGroupMembersList';
  members: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  publicSessionGroupMembersListId: Maybe<Scalars['ID']['output']>;
  roles: Maybe<Array<Maybe<PublicSessionGroupMemberRole>>>;
};

export type PublicSessionGroupUpdateInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  addPrintFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addToFirstPrintPrice?: InputMaybe<Scalars['Boolean']['input']>;
  additionalFolderSettings?: InputMaybe<Scalars['String']['input']>;
  customFilesPricing?: InputMaybe<Scalars['Boolean']['input']>;
  customPrintsPricing?: InputMaybe<Scalars['Boolean']['input']>;
  customProductsConfig?: InputMaybe<Scalars['Boolean']['input']>;
  customWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  disableLookBook?: InputMaybe<Scalars['Boolean']['input']>;
  disableZalamoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePricing?: InputMaybe<Array<InputMaybe<FilePricingInput>>>;
  hiddenForClient?: InputMaybe<Scalars['Boolean']['input']>;
  identityPhotoPaperId?: InputMaybe<Scalars['ID']['input']>;
  identityPhotoPassDigital?: InputMaybe<Scalars['Boolean']['input']>;
  individualSellSettings?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentityPhotoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  priceToAddToFirstPrint?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printsPricingListId?: InputMaybe<Scalars['ID']['input']>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sellFiles?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrints?: InputMaybe<Scalars['Boolean']['input']>;
  sellProducts?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  skipAddToFirstPrintIfFileBought?: InputMaybe<Scalars['Boolean']['input']>;
  soldFilesWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  soldFilesWatermarked?: InputMaybe<Scalars['Boolean']['input']>;
  soldWatermarkSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  watermarkConfig?: InputMaybe<ProtectionWatermarkConfigInput>;
};

export type PublicSessionMessage = {
  __typename?: 'PublicSessionMessage';
  context: Maybe<PublicSessionMessageContext>;
  message: Maybe<Array<Maybe<CustomLabel>>>;
};

export enum PublicSessionMessageContext {
  Order = 'Order',
  Welcome = 'Welcome',
}

export type PublicSessionMessageInput = {
  context: PublicSessionMessageContext;
  message: Array<InputMaybe<CustomLabelInput>>;
};

export type PublicSessionOrganization = {
  __typename?: 'PublicSessionOrganization';
  eSkarbonka: Maybe<PublicSessionOrganizationEskarbonka>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
  settings: Maybe<PublicSessionOrganizationSettings>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<PublicSessionOrganizationType>;
};

export type PublicSessionOrganizationEskarbonka = {
  __typename?: 'PublicSessionOrganizationEskarbonka';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicLinkHash: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationEskarbonkaProgress = {
  __typename?: 'PublicSessionOrganizationEskarbonkaProgress';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicLinkHash: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationEskarbonkaPublicView = {
  __typename?: 'PublicSessionOrganizationEskarbonkaPublicView';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationGroup = {
  __typename?: 'PublicSessionOrganizationGroup';
  name: Maybe<Scalars['String']['output']>;
  publicSessionOrganizationGroupId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type PublicSessionOrganizationGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublicSessionOrganizationGroupsList = {
  __typename?: 'PublicSessionOrganizationGroupsList';
  list: Maybe<Array<Maybe<PublicSessionOrganizationGroup>>>;
  publicSessionOrganizationGroupsListId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationMember = {
  __typename?: 'PublicSessionOrganizationMember';
  avatar: Maybe<Scalars['String']['output']>;
  avatarHeight: Maybe<Scalars['Int']['output']>;
  avatarWidth: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  publicSessionOrganizationMemberId: Maybe<Scalars['ID']['output']>;
  roles: Maybe<Array<Maybe<PublicSessionOrganizationMemberRole>>>;
  scale: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type PublicSessionOrganizationMemberInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarHeight?: InputMaybe<Scalars['Int']['input']>;
  avatarWidth?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roles: Array<InputMaybe<PublicSessionOrganizationMemberRole>>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export enum PublicSessionOrganizationMemberRole {
  Director = 'Director',
  Office = 'Office',
  Teacher = 'Teacher',
  ViceDirector = 'ViceDirector',
}

export type PublicSessionOrganizationRole = {
  __typename?: 'PublicSessionOrganizationRole';
  publicSessionOrganizationRoleId: Maybe<Scalars['ID']['output']>;
  roleName: Maybe<Scalars['String']['output']>;
};

export type PublicSessionOrganizationSettings = {
  __typename?: 'PublicSessionOrganizationSettings';
  eSkarbonkaLimit: Maybe<Scalars['Float']['output']>;
  eSkarbonkaPercentage: Maybe<Scalars['Float']['output']>;
  eSkarbonkaPublicLinkHash: Maybe<Scalars['ID']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  officialName: Maybe<Scalars['String']['output']>;
  photo1: Maybe<PublicSessionOrganizationSettingsPhoto>;
  photo2: Maybe<PublicSessionOrganizationSettingsPhoto>;
  photo3: Maybe<PublicSessionOrganizationSettingsPhoto>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
  rspo: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
};

export type PublicSessionOrganizationSettingsPhoto = {
  __typename?: 'PublicSessionOrganizationSettingsPhoto';
  fileName: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type PublicSessionOrganizationSettingsPhotoInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type PublicSessionOrganizationSettingsUpdateInput = {
  eSkarbonkaLimit?: InputMaybe<Scalars['Float']['input']>;
  eSkarbonkaPercentage?: InputMaybe<Scalars['Float']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officialName?: InputMaybe<Scalars['String']['input']>;
  photo1?: InputMaybe<PublicSessionOrganizationSettingsPhotoInput>;
  photo2?: InputMaybe<PublicSessionOrganizationSettingsPhotoInput>;
  photo3?: InputMaybe<PublicSessionOrganizationSettingsPhotoInput>;
  rspo?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicSessionOrganizationType {
  Any = 'Any',
  Kindergarten = 'Kindergarten',
  School = 'School',
}

export type PublicSessionOrganizationUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublicSessionOrganizationsList = {
  __typename?: 'PublicSessionOrganizationsList';
  list: Maybe<Array<Maybe<PublicSessionOrganization>>>;
  publicSessionOrganizationListId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionPhotoPeople = {
  __typename?: 'PublicSessionPhotoPeople';
  assignments: Array<PublicSessionPhotoPeopleAssignment>;
  availablePeople: Array<PublicSessionPhotoPerson>;
  groupImagesByPeople: Scalars['Boolean']['output'];
};

export type PublicSessionPhotoPeopleAssignment = {
  __typename?: 'PublicSessionPhotoPeopleAssignment';
  people: Array<Scalars['ID']['output']>;
  photoId: Scalars['ID']['output'];
};

export type PublicSessionPhotoPerson = {
  __typename?: 'PublicSessionPhotoPerson';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  personId: Scalars['ID']['output'];
};

export type PublicSessionSearchResult = {
  __typename?: 'PublicSessionSearchResult';
  organizationId: Maybe<Scalars['ID']['output']>;
  userId: Maybe<Scalars['Int']['output']>;
};

export type PublicSessionSellingZalamoFrames = {
  __typename?: 'PublicSessionSellingZalamoFrames';
  context: Maybe<Scalars['String']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  organizationName: Maybe<Scalars['String']['output']>;
};

export type PublicSessionSignupChildImportAssignmentResult = {
  __typename?: 'PublicSessionSignupChildImportAssignmentResult';
  publicSessionChildId: Scalars['ID']['output'];
  publicSessionSignupImportChildId: Scalars['ID']['output'];
  updatedChildrenCount: Scalars['Int']['output'];
  updatedSubmissionCount: Scalars['Int']['output'];
};

export type PublicSessionSignupChildImportInput = {
  publicSessionChildId: Scalars['ID']['input'];
  publicSessionSignupImportChildId: Scalars['ID']['input'];
  sourceChildren: Array<PublicSessionSignupImportSourceChildInput>;
};

export type PublicSessionSignupChildrenImportResult = {
  __typename?: 'PublicSessionSignupChildrenImportResult';
  assignments: Array<PublicSessionSignupChildImportAssignmentResult>;
  children: Array<PublicSessionChild>;
};

export type PublicSessionSignupImportSourceChildInput = {
  publicSessionSignupSubmissionChildId: Scalars['ID']['input'];
  publicSessionSignupSubmissionId: Scalars['ID']['input'];
};

export type PublicSessionSortInput = {
  order: Scalars['Int']['input'];
  publicSessionGroupId: Scalars['String']['input'];
};

export type PublicSessionsList = {
  __typename?: 'PublicSessionsList';
  path: Maybe<Scalars['ID']['output']>;
  sessions: Maybe<Array<Maybe<PublicSession>>>;
};

export type Query = {
  __typename?: 'Query';
  allImagesInPublicSessionUploaded: Maybe<Scalars['Int']['output']>;
  autoLogin: Maybe<PasswordCheckResponse>;
  availablePrintConfigs: Maybe<PrintsConfig>;
  checkAuthCode: Maybe<AuthCodeCheckReponse>;
  checkPassword: Maybe<PasswordCheckResponse>;
  checkPasswordResetCode: Maybe<MutationStatus>;
  currentSupportRequests: Maybe<SupportRequestList>;
  findOldZalamoUser: Maybe<Array<Maybe<OldUser>>>;
  findSessionUserIdByHash: Maybe<PublicSessionSearchResult>;
  generateLrExportFromPhotos: Maybe<Scalars['String']['output']>;
  generateWindowsExportFromPhotos: Maybe<Scalars['String']['output']>;
  getAccessToken: Maybe<CloudAccessToken>;
  getAllMinePublicSessionOrganizationGroups: Maybe<PublicSessionOrganizationGroupsList>;
  getAttachmentDownloadTask: Maybe<Scalars['String']['output']>;
  getAuthDetails: Maybe<PublicSessionAuthDetails>;
  getAvailableGroupsInContext: Maybe<Array<Maybe<ImageContainer>>>;
  getChatConversationMessages: Maybe<Array<Maybe<Comment>>>;
  getComments: Maybe<CommentsList>;
  getCommentsWhereImTagged: Maybe<Array<Maybe<StandAloneComment>>>;
  getConversationStatus: Maybe<UserHasConversation>;
  getDisplayNameForUserId: Maybe<Scalars['String']['output']>;
  getFilesInContext: Maybe<ImageList>;
  getGroupsInPublicSession: Maybe<ListOfGroupsInSession>;
  getGroupsInPublicSessionForDisplay: Maybe<ListOfGroupsInSessionDisplay>;
  getKeywords: Maybe<KeywordsList>;
  getLastSeen: Maybe<Array<Maybe<LastVisitItem>>>;
  getMe: Maybe<SupportTeamMember>;
  getMineCommnets: Maybe<Array<Maybe<StandAloneComment>>>;
  getMinePublicSessionOrganizationGroups: Maybe<PublicSessionOrganizationGroupsList>;
  getMinePublicSessionOrganizations: Maybe<PublicSessionOrganizationsList>;
  getNamesForAllSupportedClients: Maybe<
    Array<Maybe<SupportedClientIdentifier>>
  >;
  getOldUserDetails: Maybe<OldUserDetails>;
  getPeopleInGroup: Maybe<Array<Maybe<PersonToPhotoRelation>>>;
  getPhotoSuggestions: Maybe<Array<Maybe<ImageSuggestion>>>;
  getPrintsConfig: Maybe<PrintsPricingList>;
  getPrivateSessionClientUserId: Maybe<Scalars['ID']['output']>;
  getProductsForProofing: Maybe<Array<Maybe<ProductForProofing>>>;
  getPublicSession: Maybe<PublicSession>;
  getPublicSessionForDisplay: Maybe<PublicSessionForDisplay>;
  getPublicSessionFreeDownloadAllUrl: Maybe<Scalars['String']['output']>;
  getPublicSessionGroupsDuplicatedFrom: Maybe<
    Array<Maybe<Scalars['ID']['output']>>
  >;
  getPublicSessionOrganizationContacts: Maybe<
    Array<Maybe<PublicSessionOrganizationMember>>
  >;
  getPublicSessionOrganizationEskarbonka: Maybe<PublicSessionOrganizationEskarbonkaPublicView>;
  getPublicSessionOrganizationGroupMembers: Maybe<PublicSessionGroupMembersList>;
  getPublicSessionOrganizationGroupRelatedContacts: Maybe<
    Array<Maybe<Scalars['ID']['output']>>
  >;
  getPublicSessionOrganizationMembers: Maybe<
    Array<Maybe<PublicSessionOrganizationMember>>
  >;
  getPublicSessionOrganizationRoles: Maybe<
    Array<Maybe<PublicSessionOrganizationRole>>
  >;
  getPublicSessionOrganizationSettings: Maybe<PublicSessionOrganizationSettings>;
  getPublicSessionPhotoPeople: PublicSessionPhotoPeople;
  getPublicSessionStats: Maybe<Array<Maybe<PublicSessionEvent>>>;
  getPublicSessions: Maybe<PublicSessionsList>;
  getSchoolDetails: Maybe<SchoolDetails>;
  getSupportChatMessages: Maybe<Array<Maybe<StandaloneSupportMessage>>>;
  getSupportIssue: Maybe<SupportIssue>;
  getSupportIssueAssignees: Array<SupportIssueAssignee>;
  getSupportIssueQueueSummary: SupportIssueQueueSummary;
  getSupportIssueTags: Array<Scalars['String']['output']>;
  getSupportIssueTimeline: SupportIssueTimelinePage;
  getSupportIssues: Array<SupportIssue>;
  getSupportIssuesPage: SupportIssuePage;
  getSupportOrganizationTests: SupportOrganizationTestsState;
  getSupportThreadAiAnalysisStatus: SupportThreadAiAnalysisStatus;
  getSupportThreadAiSuggestions: Array<SupportThreadAiSuggestion>;
  getSupportThreadIdDetails: Maybe<SupportRequest>;
  getSupportUserTests: SupportUserTestsState;
  getTags: Maybe<TagsList>;
  getTextSnippets: Array<TextSnippet>;
  getZalamoPrintSessionConfig: Maybe<ZalamoPrintSessionConfig>;
  getZalamoPrintSessionRenderInProgress: Maybe<Scalars['Boolean']['output']>;
  hasOwnOrdersWithFlyersOrInDuplicates: Maybe<Scalars['Boolean']['output']>;
  loginExists: Maybe<LoginCheckResponse>;
  me: Maybe<PhotographerAccount>;
  mineDeliveryMethods: Maybe<Array<Maybe<DeliveryMethod>>>;
  minePrintsPricingLists: Maybe<Array<Maybe<PrintsPricingList>>>;
  mineProducts: Maybe<Array<Maybe<Product>>>;
  mineStatus: Maybe<MineStatus>;
  mySupportIssueNotifications: SupportIssueNotificationPage;
  newZalamoStats: Maybe<NewZalamoStats>;
  publicSessionChildrenList: Maybe<PublicSessionChildrenList>;
  publicSessionOrganizationGroupChildrenList: Maybe<PublicSessionChildrenList>;
  searchZalamoKnowledgeBase: ZalamoKnowledgeBaseSearchResult;
  showEnabledPaymentMethods: Maybe<Array<Maybe<PaymentMethod>>>;
  twoFactorAuthenticatorStatus: TwoFactorAuthenticatorStatus;
  unseenComments: Maybe<Array<Maybe<UserHasConversation>>>;
  validateNiceUrl: Maybe<NiceUrlValidationStatus>;
  x: Maybe<Scalars['String']['output']>;
};

export type QueryAllImagesInPublicSessionUploadedArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryAutoLoginArgs = {
  token?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAvailablePrintConfigsArgs = {
  lang?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckAuthCodeArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['ID']['input'];
  trustThisDevice: Scalars['Boolean']['input'];
  twoFactorChallengeId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCheckPasswordArgs = {
  deviceId: Scalars['ID']['input'];
  deviceName: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type QueryCheckPasswordResetCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type QueryCurrentSupportRequestsArgs = {
  ownerState: SupportOwnerState;
};

export type QueryFindOldZalamoUserArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFindSessionUserIdByHashArgs = {
  hash: Scalars['String']['input'];
};

export type QueryGenerateLrExportFromPhotosArgs = {
  photoIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGenerateWindowsExportFromPhotosArgs = {
  photoIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetAccessTokenArgs = {
  context?: InputMaybe<UploadContext>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type: UploadFileType;
};

export type QueryGetAllMinePublicSessionOrganizationGroupsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetAttachmentDownloadTaskArgs = {
  messageId: Scalars['ID']['input'];
};

export type QueryGetAuthDetailsArgs = {
  publicSessionHash: Scalars['ID']['input'];
};

export type QueryGetAvailableGroupsInContextArgs = {
  context?: InputMaybe<ImagesContainer>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetChatConversationMessagesArgs = {
  context: CommentContext;
  contextId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCommentsArgs = {
  context: CommentContext;
  contextId: Scalars['ID']['input'];
};

export type QueryGetCommentsWhereImTaggedArgs = {
  month: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetConversationStatusArgs = {
  context: CommentContext;
  contextId: Scalars['ID']['input'];
};

export type QueryGetDisplayNameForUserIdArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetFilesInContextArgs = {
  context: Scalars['String']['input'];
  contextId: Scalars['ID']['input'];
};

export type QueryGetGroupsInPublicSessionArgs = {
  publicSessionId: Scalars['String']['input'];
};

export type QueryGetGroupsInPublicSessionForDisplayArgs = {
  publicSessionId: Scalars['String']['input'];
};

export type QueryGetKeywordsArgs = {
  context: ZalamoObject;
  contextId: Scalars['ID']['input'];
};

export type QueryGetLastSeenArgs = {
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetMineCommnetsArgs = {
  month: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetMinePublicSessionOrganizationGroupsArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetMinePublicSessionOrganizationsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationType?: InputMaybe<PublicSessionOrganizationType>;
};

export type QueryGetOldUserDetailsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetPeopleInGroupArgs = {
  photoGroupId: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetPhotoSuggestionsArgs = {
  context?: InputMaybe<ImagesContainer>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetPrintsConfigArgs = {
  context: PrintsPricingContext;
  contextId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetPrivateSessionClientUserIdArgs = {
  privateSessionId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionArgs = {
  publicSessionId: Scalars['String']['input'];
};

export type QueryGetPublicSessionForDisplayArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionFreeDownloadAllUrlArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionGroupsDuplicatedFromArgs = {
  publicSessionGroupId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationContactsArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationEskarbonkaArgs = {
  publicLinkHash: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationGroupMembersArgs = {
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationGroupRelatedContactsArgs = {
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationMembersArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationRolesArgs = {
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionOrganizationSettingsArgs = {
  publicSessionOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetPublicSessionPhotoPeopleArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionStatsArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryGetPublicSessionsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetSchoolDetailsArgs = {
  schoolId: Scalars['ID']['input'];
};

export type QueryGetSupportChatMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetSupportIssueArgs = {
  issueId: Scalars['ID']['input'];
};

export type QueryGetSupportIssueAssigneesArgs = {
  supportTeamId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSupportIssueQueueSummaryArgs = {
  filter?: InputMaybe<SupportIssueFilterInput>;
};

export type QueryGetSupportIssueTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  supportTeamId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSupportIssueTimelineArgs = {
  issueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetSupportIssuesArgs = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sourceSupportThreadId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<SupportIssueStatus>>;
};

export type QueryGetSupportIssuesPageArgs = {
  filter?: InputMaybe<SupportIssueFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetSupportOrganizationTestsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetSupportThreadAiAnalysisStatusArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type QueryGetSupportThreadAiSuggestionsArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type QueryGetSupportThreadIdDetailsArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type QueryGetSupportUserTestsArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryGetTagsArgs = {
  context: ZalamoObject;
  organizationId: Scalars['ID']['input'];
};

export type QueryGetZalamoPrintSessionConfigArgs = {
  zalamoPrintSessionConfigId: Scalars['ID']['input'];
};

export type QueryGetZalamoPrintSessionRenderInProgressArgs = {
  zalamoPrintSessionConfigId: Scalars['ID']['input'];
};

export type QueryHasOwnOrdersWithFlyersOrInDuplicatesArgs = {
  publicSessionId: Scalars['ID']['input'];
};

export type QueryLoginExistsArgs = {
  login: Scalars['String']['input'];
};

export type QueryMeArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMineDeliveryMethodsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMinePrintsPricingListsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMineProductsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryMySupportIssueNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPublicSessionChildrenListArgs = {
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
  publicSessionOrganizationId: Scalars['ID']['input'];
};

export type QueryPublicSessionOrganizationGroupChildrenListArgs = {
  publicSessionOrganizationGroupId: Scalars['ID']['input'];
};

export type QuerySearchZalamoKnowledgeBaseArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShowEnabledPaymentMethodsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUnseenCommentsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryValidateNiceUrlArgs = {
  contextId: Scalars['ID']['input'];
  currentContext?: InputMaybe<NiceUrlContainer>;
  niceUrl: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RegisterPhotographerFinalizeResponse = {
  __typename?: 'RegisterPhotographerFinalizeResponse';
  firstName: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  token: Maybe<Scalars['String']['output']>;
};

export enum RegisterPhotographerInitErrorCode {
  EmailAlreadyTaken = 'EMAIL_ALREADY_TAKEN',
  PhoneAlreadyTaken = 'PHONE_ALREADY_TAKEN',
}

export type RegisterPhotographerInitResponse = {
  __typename?: 'RegisterPhotographerInitResponse';
  errorCode: Maybe<RegisterPhotographerInitErrorCode>;
  smsSent: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
};

export type RegisterPhotographerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type RetouchLevel = {
  __typename?: 'RetouchLevel';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  retouchLevelId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevelInput = {
  label: Array<InputMaybe<CustomLabelInput>>;
  price: Array<InputMaybe<PriceConfigInput>>;
  retouchLevelId: Scalars['ID']['input'];
};

export type SampleSupplierOrderConfig = {
  __typename?: 'SampleSupplierOrderConfig';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  productType: Maybe<ProductType>;
  status: Maybe<Scalars['Boolean']['output']>;
  supplierId: Scalars['ID']['output'];
};

export type SampleSupplierOrderInput = {
  file: Scalars['ID']['input'];
  fileHeight: Scalars['Int']['input'];
  fileWidth: Scalars['Int']['input'];
};

export type SamplesSupplierOrderInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  productType?: InputMaybe<ProductType>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDataProcessingAgreementDraftInput = {
  businessType?: InputMaybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails?: InputMaybe<DataAgreementDetailsInput>;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type SchoolDetails = {
  __typename?: 'SchoolDetails';
  ai: Maybe<SchoolDetailsAi>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactPhone: Maybe<Scalars['String']['output']>;
  decisionMakerName: Maybe<Scalars['String']['output']>;
  decisionMakerPosition: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailSent: Maybe<Scalars['Boolean']['output']>;
  emailSentDate: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  pickedBy: Maybe<Scalars['String']['output']>;
  schoolDetailsId: Maybe<Scalars['ID']['output']>;
  showChips: Maybe<Scalars['Boolean']['output']>;
  showSimple: Maybe<Scalars['Boolean']['output']>;
  uid: Maybe<Scalars['ID']['output']>;
};

export type SchoolDetailsAi = {
  __typename?: 'SchoolDetailsAI';
  denominator: Maybe<Scalars['String']['output']>;
  genitive: Maybe<Scalars['String']['output']>;
};

export type SchoolDetailsInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  decisionMakerName?: InputMaybe<Scalars['String']['input']>;
  decisionMakerPosition?: InputMaybe<Scalars['String']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  emailSentDate?: InputMaybe<Scalars['Int']['input']>;
  pickedBy?: InputMaybe<Scalars['String']['input']>;
  showChips?: InputMaybe<Scalars['Boolean']['input']>;
  showSimple?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionAlbumLookBookConfig = {
  __typename?: 'SessionAlbumLookBookConfig';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionAlbumLookBookConfigForDisplay = {
  __typename?: 'SessionAlbumLookBookConfigForDisplay';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionAlbumLookBookConfigInput = {
  commission?: InputMaybe<Scalars['Int']['input']>;
  excludedMaterials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  labIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionDuplicationResult = {
  __typename?: 'SessionDuplicationResult';
  duplicate: Maybe<PublicSession>;
  original: Maybe<PublicSession>;
  sessionDuplicationResult: Maybe<Scalars['ID']['output']>;
};

export type SessionLookBookConfig = {
  __typename?: 'SessionLookBookConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  personalization: Maybe<DecorationPreConfig>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfig>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfig>;
  triplexConfig: Maybe<SessionTriplexLookBookConfig>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfig>;
};

export type SessionLookBookConfigForDisplay = {
  __typename?: 'SessionLookBookConfigForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfigForDisplay>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
  triplexConfig: Maybe<SessionTriplexLookBookConfigForDisplay>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
};

export type SessionLookBookConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  albumConfig?: InputMaybe<SessionAlbumLookBookConfigInput>;
  personalization?: InputMaybe<DecorationPreConfigInput>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  printFramesConfig?: InputMaybe<SessionPrintFramesLookBookConfigInput>;
  sellAlbums?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrintFrames?: InputMaybe<Scalars['Boolean']['input']>;
  sellTambour?: InputMaybe<Scalars['Boolean']['input']>;
  sellTriplex?: InputMaybe<Scalars['Boolean']['input']>;
  sellWallDecor?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tambourConfig?: InputMaybe<SessionWallDecorLookBookConfigInput>;
  triplexConfig?: InputMaybe<SessionTriplexLookBookConfigInput>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  wallDecorConfig?: InputMaybe<SessionWallDecorLookBookConfigInput>;
};

export enum SessionOccasion {
  Baphthism = 'Baphthism',
  Birthday = 'Birthday',
  FirstBirthday = 'FirstBirthday',
  FirstCommunion = 'FirstCommunion',
  Newborn = 'Newborn',
  Wedding = 'Wedding',
}

export type SessionPrintFrameConfig = {
  __typename?: 'SessionPrintFrameConfig';
  color: Maybe<Scalars['String']['output']>;
  format: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  sessionPrintFrameConfigId: Maybe<Scalars['ID']['output']>;
  shape: Maybe<Scalars['String']['output']>;
};

export type SessionPrintFramesLookBookConfig = {
  __typename?: 'SessionPrintFramesLookBookConfig';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  commission: Maybe<Scalars['Int']['output']>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionPrintFramesLookBookConfigForDisplay = {
  __typename?: 'SessionPrintFramesLookBookConfigForDisplay';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionPrintFramesLookBookConfigInput = {
  availableColors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  commission?: InputMaybe<Scalars['Int']['input']>;
  limitColors?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfig = {
  __typename?: 'SessionTriplexLookBookConfig';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  commission: Maybe<Scalars['Int']['output']>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigForDisplay = {
  __typename?: 'SessionTriplexLookBookConfigForDisplay';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labId: Maybe<Scalars['String']['output']>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigInput = {
  availableMaterials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  commission?: InputMaybe<Scalars['Int']['input']>;
  labIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfig = {
  __typename?: 'SessionWallDecorLookBookConfig';
  commission: Maybe<Scalars['Int']['output']>;
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labIds: Maybe<Scalars['ID']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigForDisplay = {
  __typename?: 'SessionWallDecorLookBookConfigForDisplay';
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigInput = {
  commission?: InputMaybe<Scalars['Int']['input']>;
  disablePersonalizationOnSinglePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  labIds?: InputMaybe<Scalars['ID']['input']>;
  preConfig?: InputMaybe<Scalars['String']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SinglePhoto = {
  __typename?: 'SinglePhoto';
  created: Maybe<Scalars['Int']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  fileUploaded: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  isRaw: Maybe<Scalars['Boolean']['output']>;
  isRetouched: Maybe<Scalars['Boolean']['output']>;
  localPath: Maybe<Scalars['String']['output']>;
  originalHeight: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  originalWidth: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  shootDate: Maybe<Scalars['Int']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesUniversalWatermarkConfigInput = {
  horizontal: SoldFilesWatermarkConfigInput;
  soldFilesUniversalWatermarkConfigId?: InputMaybe<Scalars['ID']['input']>;
  vertical: SoldFilesWatermarkConfigInput;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigInput = {
  alpha: Scalars['Float']['input'];
  config: SoldFilesWatermarkConfigPositionInput;
  file: Scalars['String']['input'];
  soldFilesWatermarkConfigId: Scalars['ID']['input'];
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type SoldFilesWatermarkConfigPositionInput = {
  left: Scalars['Float']['input'];
  soldFilesWatermarkConfigPositionId: Scalars['ID']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type SortInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  photoInGroupId: Scalars['ID']['input'];
};

export type StandAloneComment = {
  __typename?: 'StandAloneComment';
  authorId: Maybe<Scalars['ID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  context: Maybe<CommentContext>;
  contextId: Maybe<Scalars['ID']['output']>;
  date: Maybe<Scalars['Int']['output']>;
  type: Maybe<CommnetType>;
};

export type StandaloneSupportMessage = {
  __typename?: 'StandaloneSupportMessage';
  authorId: Maybe<Scalars['ID']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['Int']['output']>;
  standaloneSupportMessageId: Maybe<Scalars['ID']['output']>;
  type: Maybe<CommnetType>;
};

export type StartDataProcessingAgreementSigningInput = {
  businessType: DataProcessingAgreementBusinessType;
  dataAgreementDetails: DataAgreementDetailsInput;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type StepPricing = {
  __typename?: 'StepPricing';
  firstStep: Maybe<Scalars['Int']['output']>;
  isFirstStepFree: Maybe<Scalars['Boolean']['output']>;
  lastStepPrice: Maybe<Array<Maybe<PriceConfig>>>;
  mode: Maybe<StepPricingMode>;
  steps: Maybe<Array<Maybe<PriceStep>>>;
};

export type StepPricingInput = {
  firstStep: Scalars['Int']['input'];
  isFirstStepFree: Scalars['Boolean']['input'];
  lastStepPrice: Array<InputMaybe<PriceConfigInput>>;
  mode: StepPricingMode;
  steps: Array<InputMaybe<PriceStepInput>>;
};

export enum StepPricingMode {
  Bundles = 'Bundles',
  ForAll = 'ForAll',
  ForOverTreshold = 'ForOverTreshold',
  None = 'None',
}

export type SubdomainUpdateResult = {
  __typename?: 'SubdomainUpdateResult';
  organization: Maybe<Organization>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  commentsThreadUpdated: Maybe<UserHasConversation>;
  messageToSupportSent: Maybe<StandaloneSupportMessage>;
  newCommentAdded: Maybe<Comment>;
  supportIssueNotificationCreated: SupportIssueNotification;
  supportThreadAiAnalysisStatusUpdated: SupportThreadAiAnalysisStatus;
  supportThreadCreatedByUser: Maybe<SupportRequest>;
  supportThreadUpdated: Maybe<SupportRequest>;
};

export type SubscriptionCommentsThreadUpdatedArgs = {
  organizationId: Scalars['ID']['input'];
  watcherId: Scalars['ID']['input'];
};

export type SubscriptionMessageToSupportSentArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type SubscriptionNewCommentAddedArgs = {
  context: CommentContext;
  contextId: Scalars['ID']['input'];
  watcherId: Scalars['ID']['input'];
};

export type SubscriptionSupportThreadAiAnalysisStatusUpdatedArgs = {
  supportThreadId: Scalars['ID']['input'];
};

export type SubscriptionSupportThreadCreatedByUserArgs = {
  supportTeamId: Scalars['ID']['input'];
};

export type SubscriptionSupportThreadUpdatedArgs = {
  supportTeamId?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplierOrdersConfig = {
  __typename?: 'SupplierOrdersConfig';
  file: Maybe<Scalars['ID']['output']>;
  suppliers: Maybe<Array<Maybe<SampleSupplierOrderConfig>>>;
};

export type SupplierPrintsImportConfig = {
  count: Scalars['Int']['input'];
  hasFrame: Scalars['Boolean']['input'];
  printFormatId: Scalars['ID']['input'];
  printPaperId: Scalars['ID']['input'];
  targetFakeGroupId: Scalars['ID']['input'];
};

export type SupportConversationExportResult = {
  __typename?: 'SupportConversationExportResult';
  exportedConversations: Scalars['Int']['output'];
  exportedMessages: Scalars['Int']['output'];
  generatedAt: Scalars['String']['output'];
  outputDir: Scalars['String']['output'];
  skippedConversations: Scalars['Int']['output'];
};

export type SupportIssue = {
  __typename?: 'SupportIssue';
  allowedStatusTransitions: Array<SupportIssueStatus>;
  assigneeUserId: Maybe<Scalars['ID']['output']>;
  closedAt: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  customerSnapshot: Maybe<SupportIssueCustomerSnapshot>;
  deadlineDate: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  extractedLinks: Array<SupportIssueLink>;
  issueId: Scalars['ID']['output'];
  lastReopenReason: Maybe<Scalars['String']['output']>;
  lastReopenedAt: Maybe<Scalars['Int']['output']>;
  lastReopenedBy: Maybe<Scalars['ID']['output']>;
  messageSummary: Maybe<Scalars['String']['output']>;
  nextActionAt: Maybe<Scalars['Int']['output']>;
  nextActionNote: Maybe<Scalars['String']['output']>;
  nextActionOwnerUserId: Maybe<Scalars['ID']['output']>;
  nextActionType: Maybe<SupportIssueNextActionType>;
  organizationId: Scalars['ID']['output'];
  priority: SupportIssuePriority;
  reopenCount: Scalars['Int']['output'];
  reporterUserId: Scalars['ID']['output'];
  resolutionCode: Maybe<SupportIssueResolutionCode>;
  resolutionSummary: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['Int']['output']>;
  resolvedBy: Maybe<Scalars['ID']['output']>;
  sourceContext: Maybe<Scalars['String']['output']>;
  sourceContextId: Maybe<Scalars['ID']['output']>;
  sourceConversationId: Maybe<Scalars['ID']['output']>;
  sourceSupportThreadId: Maybe<Scalars['ID']['output']>;
  sourceType: SupportIssueSourceType;
  status: SupportIssueStatus;
  supportTeamId: Scalars['ID']['output'];
  supportedUserId: Maybe<Scalars['ID']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  triagedAt: Maybe<Scalars['Int']['output']>;
  triagedBy: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type SupportIssueAssignee = {
  __typename?: 'SupportIssueAssignee';
  displayName: Maybe<Scalars['String']['output']>;
  login: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type SupportIssueAuditChange = {
  __typename?: 'SupportIssueAuditChange';
  field: Scalars['String']['output'];
  nextValue: Maybe<Scalars['String']['output']>;
  previousValue: Maybe<Scalars['String']['output']>;
};

export type SupportIssueAuditEvent = {
  __typename?: 'SupportIssueAuditEvent';
  actorUserId: Scalars['ID']['output'];
  changes: Array<SupportIssueAuditChange>;
  eventId: Scalars['ID']['output'];
  eventType: SupportIssueAuditEventType;
  issueVersion: Scalars['Int']['output'];
  occurredAt: Scalars['Int']['output'];
};

export enum SupportIssueAuditEventType {
  Created = 'Created',
  StatusChanged = 'StatusChanged',
  Updated = 'Updated',
}

export type SupportIssueCustomerSnapshot = {
  __typename?: 'SupportIssueCustomerSnapshot';
  clientSessionsCount: Maybe<Scalars['Int']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  photographerAlbumDesignCount: Maybe<Scalars['Int']['output']>;
  photographerBookingsCount: Maybe<Scalars['Int']['output']>;
  photographerGalleryCount: Maybe<Scalars['Int']['output']>;
  photographerPrivateSessionsCount: Maybe<Scalars['Int']['output']>;
  photographerPublicSessionsCount: Maybe<Scalars['Int']['output']>;
  photographerWeddingCount: Maybe<Scalars['Int']['output']>;
  sessions: Maybe<Array<Maybe<OldSessionDetails>>>;
  type: Maybe<Array<Maybe<OldUserType>>>;
  userId: Maybe<Scalars['ID']['output']>;
  verifiedPhone: Maybe<Scalars['Boolean']['output']>;
};

export enum SupportIssueDeadlineBucket {
  All = 'All',
  Next7Days = 'Next7Days',
  NoDate = 'NoDate',
  Overdue = 'Overdue',
  Today = 'Today',
}

export type SupportIssueFilterInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  deadlineBucket?: InputMaybe<SupportIssueDeadlineBucket>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<SupportIssuePriority>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<SupportIssueSourceType>;
  status?: InputMaybe<Array<SupportIssueStatus>>;
  supportTeamId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  unassignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupportIssueLink = {
  __typename?: 'SupportIssueLink';
  domain: Maybe<Scalars['String']['output']>;
  firstSeenAt: Maybe<Scalars['Int']['output']>;
  firstSeenMessageId: Maybe<Scalars['ID']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SupportIssueListItem = {
  __typename?: 'SupportIssueListItem';
  assigneeUserId: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Int']['output'];
  deadlineDate: Maybe<Scalars['String']['output']>;
  issueId: Scalars['ID']['output'];
  nextActionAt: Maybe<Scalars['Int']['output']>;
  nextActionNote: Maybe<Scalars['String']['output']>;
  nextActionOwnerUserId: Maybe<Scalars['ID']['output']>;
  nextActionType: Maybe<SupportIssueNextActionType>;
  organizationId: Scalars['ID']['output'];
  priority: SupportIssuePriority;
  sourceContext: Maybe<Scalars['String']['output']>;
  sourceConversationId: Maybe<Scalars['ID']['output']>;
  sourceSupportThreadId: Maybe<Scalars['ID']['output']>;
  sourceType: SupportIssueSourceType;
  status: SupportIssueStatus;
  supportTeamId: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export enum SupportIssueNextActionType {
  AwaitExternalParty = 'AwaitExternalParty',
  ContactCustomer = 'ContactCustomer',
  InternalFollowUp = 'InternalFollowUp',
  Other = 'Other',
  ReviewCustomerResponse = 'ReviewCustomerResponse',
}

export type SupportIssueNotification = {
  __typename?: 'SupportIssueNotification';
  actorUserId: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  changes: Array<SupportIssueAuditChange>;
  eventId: Scalars['ID']['output'];
  eventType: SupportIssueAuditEventType;
  issueId: Scalars['ID']['output'];
  issueVersion: Scalars['Int']['output'];
  notificationId: Scalars['ID']['output'];
  occurredAt: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  readAt: Maybe<Scalars['Int']['output']>;
  recipientUserId: Scalars['ID']['output'];
  supportTeamId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SupportIssueNotificationPage = {
  __typename?: 'SupportIssueNotificationPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<SupportIssueNotification>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type SupportIssuePage = {
  __typename?: 'SupportIssuePage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<SupportIssueListItem>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum SupportIssuePriority {
  High = 'High',
  Low = 'Low',
  Normal = 'Normal',
  Urgent = 'Urgent',
}

export type SupportIssueQueueSummary = {
  __typename?: 'SupportIssueQueueSummary';
  countsByStatus: Array<SupportIssueStatusCount>;
  due7d: Scalars['Int']['output'];
  dueToday: Scalars['Int']['output'];
  noDeadlineCount: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
  urgentCount: Scalars['Int']['output'];
};

export enum SupportIssueResolutionCode {
  CannotReproduce = 'CannotReproduce',
  ConfigurationChanged = 'ConfigurationChanged',
  Duplicate = 'Duplicate',
  InformationProvided = 'InformationProvided',
  NotAnIssue = 'NotAnIssue',
  Other = 'Other',
  Solved = 'Solved',
  WorkaroundProvided = 'WorkaroundProvided',
}

export enum SupportIssueSourceType {
  Conversation = 'Conversation',
  Manual = 'Manual',
  SupportThread = 'SupportThread',
}

export enum SupportIssueStatus {
  Closed = 'Closed',
  New = 'New',
  Open = 'Open',
  Resolved = 'Resolved',
  WaitingForCustomer = 'WaitingForCustomer',
  WaitingInternal = 'WaitingInternal',
}

export type SupportIssueStatusCount = {
  __typename?: 'SupportIssueStatusCount';
  count: Scalars['Int']['output'];
  status: SupportIssueStatus;
};

export type SupportIssueTimelinePage = {
  __typename?: 'SupportIssueTimelinePage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<SupportIssueAuditEvent>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum SupportMessageType {
  Attachments = 'Attachments',
  Picture = 'Picture',
  Text = 'Text',
}

export type SupportMobileDeviceDetails = {
  __typename?: 'SupportMobileDeviceDetails';
  currentUser: Maybe<SupportMobileDeviceUser>;
  deviceId: Scalars['ID']['output'];
  firstSeenAt: Maybe<Scalars['String']['output']>;
  isLoggedIn: Scalars['Boolean']['output'];
  language: Maybe<Scalars['String']['output']>;
  linkedUsers: Array<SupportMobileDeviceUser>;
  model: Maybe<Scalars['String']['output']>;
  notificationsAuthorized: Maybe<Scalars['Boolean']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  pushAvailable: Scalars['Boolean']['output'];
  summaryLabel: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
  visitedOrders: Array<SupportMobileDeviceVisit>;
  visitedPublicSessions: Array<SupportMobileDeviceVisit>;
  visitedSignups: Array<SupportMobileDeviceVisit>;
};

export type SupportMobileDeviceUser = {
  __typename?: 'SupportMobileDeviceUser';
  displayName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstLinkedAt: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastLinkedAt: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type SupportMobileDeviceVisit = {
  __typename?: 'SupportMobileDeviceVisit';
  childId: Maybe<Scalars['ID']['output']>;
  hash: Maybe<Scalars['String']['output']>;
  lastVisitedAt: Scalars['String']['output'];
  orderId: Maybe<Scalars['ID']['output']>;
  signupId: Maybe<Scalars['ID']['output']>;
};

export type SupportOrganizationTestsState = {
  __typename?: 'SupportOrganizationTestsState';
  activeTests: Array<OrganizationTest>;
  availableTests: Array<OrganizationTest>;
  organizationId: Scalars['ID']['output'];
};

export enum SupportOwnerState {
  All = 'All',
  Mine = 'Mine',
  MineOrUnAssigned = 'MineOrUnAssigned',
  UnAssigned = 'UnAssigned',
}

export type SupportRequest = {
  __typename?: 'SupportRequest';
  context: Maybe<ZalamoSupportContext>;
  conversationId: Maybe<Scalars['ID']['output']>;
  currentSupportManagerId: Maybe<Scalars['ID']['output']>;
  isAnswered: Maybe<Scalars['Boolean']['output']>;
  isRead: Maybe<Scalars['Boolean']['output']>;
  isSeenByClient: Maybe<Scalars['Boolean']['output']>;
  isSolved: Maybe<Scalars['Boolean']['output']>;
  lastMessage: Maybe<Scalars['String']['output']>;
  lastMessageDate: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use mobileDevices for multi-device mobile users. */
  mobileDevice: Maybe<SupportMobileDeviceDetails>;
  mobileDevices: Array<SupportMobileDeviceDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  ownerState: Maybe<SupportOwnerState>;
  studio: Maybe<SupportRequestStudio>;
  supportRequestId: Maybe<Scalars['ID']['output']>;
  supportTeamId: Maybe<Scalars['ID']['output']>;
  supportedUserId: Maybe<Scalars['ID']['output']>;
  version: Maybe<SupportSystemVersion>;
};

export type SupportRequestList = {
  __typename?: 'SupportRequestList';
  requests: Maybe<Array<Maybe<SupportRequest>>>;
  supportRequestListId: Maybe<Scalars['ID']['output']>;
};

export type SupportRequestStudio = {
  __typename?: 'SupportRequestStudio';
  name: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  zalamoPayConfigFinished: Maybe<Scalars['Boolean']['output']>;
  zalamoPayRegisterInProgress: Maybe<Scalars['Boolean']['output']>;
};

export enum SupportSystemVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export type SupportTeamMember = {
  __typename?: 'SupportTeamMember';
  activeSupportTeams: Array<SupportTeamOption>;
  supportTeamId: Maybe<Scalars['ID']['output']>;
  supportTeamMemberId: Maybe<Scalars['ID']['output']>;
  teamMemberId: Maybe<Scalars['ID']['output']>;
};

export type SupportTeamOption = {
  __typename?: 'SupportTeamOption';
  label: Scalars['String']['output'];
  supportTeamId: Scalars['ID']['output'];
};

export enum SupportThreadAiAnalysisState {
  Completed = 'Completed',
  Failed = 'Failed',
  Idle = 'Idle',
  InProgress = 'InProgress',
}

export type SupportThreadAiAnalysisStatus = {
  __typename?: 'SupportThreadAiAnalysisStatus';
  errorMessage: Maybe<Scalars['String']['output']>;
  status: SupportThreadAiAnalysisState;
  suggestionsCount: Scalars['Int']['output'];
  supportThreadId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SupportThreadAiSuggestion = {
  __typename?: 'SupportThreadAiSuggestion';
  answer: Scalars['String']['output'];
  averageRating: Maybe<Scalars['Float']['output']>;
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['Int']['output'];
  myRating: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  ratings: Array<SupportThreadAiSuggestionRating>;
  ratingsCount: Scalars['Int']['output'];
  supportThreadAiSuggestionId: Scalars['ID']['output'];
  supportThreadId: Scalars['ID']['output'];
};

export type SupportThreadAiSuggestionRating = {
  __typename?: 'SupportThreadAiSuggestionRating';
  createdAt: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
  supportUserId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SupportUserTestsState = {
  __typename?: 'SupportUserTestsState';
  activeTests: Array<UserTest>;
  availableTests: Array<UserTest>;
  userId: Scalars['ID']['output'];
};

export type SupportedClientIdentifier = {
  __typename?: 'SupportedClientIdentifier';
  email: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  organizationName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  supportedClientIdentifierId: Maybe<Scalars['ID']['output']>;
};

export type TabloForDisplay = {
  __typename?: 'TabloForDisplay';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<TabloSize>;
  tabloForDisplayId: Maybe<Scalars['ID']['output']>;
};

export enum TabloSize {
  S15x20 = 's15x20',
  S20x15 = 's20x15',
  S20x30 = 's20x30',
}

export type TagsList = {
  __typename?: 'TagsList';
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TextSnippet = {
  __typename?: 'TextSnippet';
  content: Array<I18nText>;
  createdAt: Maybe<Scalars['Int']['output']>;
  supportSnippetId: Scalars['ID']['output'];
  supportTeamId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['Int']['output']>;
};

export type ThreadUpdateInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isSolved?: InputMaybe<Scalars['Boolean']['input']>;
  supportTeamMemberId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriplexRenderPreviewConfig = {
  __typename?: 'TriplexRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  triplexRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type TriplexRenderPreviewConfigInput = {
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TwoFactorAuthenticatorErrorCode {
  AlreadyEnabled = 'ALREADY_ENABLED',
  InvalidCode = 'INVALID_CODE',
  InvalidPassword = 'INVALID_PASSWORD',
  NotEnabled = 'NOT_ENABLED',
  RateLimited = 'RATE_LIMITED',
  SetupNotFound = 'SETUP_NOT_FOUND',
}

export type TwoFactorAuthenticatorStatus = {
  __typename?: 'TwoFactorAuthenticatorStatus';
  enabled: Scalars['Boolean']['output'];
  enabledAt: Maybe<Scalars['Int']['output']>;
  recoveryCodesRemaining: Scalars['Int']['output'];
};

export enum TwoFactorMethod {
  Authenticator = 'AUTHENTICATOR',
  Sms = 'SMS',
}

export type UpdateFilesConfig = {
  count: Scalars['Int']['input'];
  isFull: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
};

export type UpdatePrintAndFileConfig = {
  filesConfig?: InputMaybe<Array<InputMaybe<UpdateFilesConfig>>>;
  forcedImage?: InputMaybe<ForcedImageConfigUpdate>;
  groups: Array<InputMaybe<Scalars['String']['input']>>;
  mode?: InputMaybe<FilesAndPrintsPackageType>;
  printAndFileConfigId?: InputMaybe<Scalars['ID']['input']>;
  printsCount?: InputMaybe<Array<InputMaybe<UpdatePrintsCount>>>;
};

export type UpdatePrintsCount = {
  count: Scalars['Int']['input'];
  printFormatId: Scalars['String']['input'];
  printPaperId: Scalars['String']['input'];
};

export type UpdateProductConfig = {
  config: Scalars['String']['input'];
  customName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ProductMode>;
  productId: Scalars['String']['input'];
  productInPackageId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export type UpdateProductPackage = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printAndFileConfig: Array<InputMaybe<UpdatePrintAndFileConfig>>;
  productConfig: Array<InputMaybe<UpdateProductConfig>>;
  productPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupportIssueInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  deadlineDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedVersion: Scalars['Int']['input'];
  nextActionAt?: InputMaybe<Scalars['Int']['input']>;
  nextActionNote?: InputMaybe<Scalars['String']['input']>;
  nextActionOwnerUserId?: InputMaybe<Scalars['ID']['input']>;
  nextActionType?: InputMaybe<SupportIssueNextActionType>;
  priority?: InputMaybe<SupportIssuePriority>;
  reopenReason?: InputMaybe<Scalars['String']['input']>;
  resolutionCode?: InputMaybe<SupportIssueResolutionCode>;
  resolutionSummary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupportIssueStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadContext {
  BookingPortfolio = 'BookingPortfolio',
  ChatAttachment = 'ChatAttachment',
  CompetitionEntry = 'CompetitionEntry',
  ConfigTemplate = 'ConfigTemplate',
  CoverBooking = 'CoverBooking',
  CoverPrivate = 'CoverPrivate',
  CoverPublic = 'CoverPublic',
  DecorationFile = 'DecorationFile',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  FileWatermark = 'FileWatermark',
  ImageSampleForSessionFolder = 'ImageSampleForSessionFolder',
  LookBookPreview = 'LookBookPreview',
  Model3D = 'Model3D',
  OrganizationLogo = 'OrganizationLogo',
  OrganizationPromoFlyer = 'OrganizationPromoFlyer',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  PrivateSessionPackage = 'PrivateSessionPackage',
  Product = 'Product',
  ProductSampleOrder = 'ProductSampleOrder',
  PublicSessionChild = 'PublicSessionChild',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganizationLogo = 'PublicSessionOrganizationLogo',
  PublicSessionOrganizationMemberAvatar = 'PublicSessionOrganizationMemberAvatar',
  PublicSessionPackage = 'PublicSessionPackage',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  SupplierPrintsOrder = 'SupplierPrintsOrder',
  SupplierProductInOrder = 'SupplierProductInOrder',
  SupplierProductOrder = 'SupplierProductOrder',
  UserAvatar = 'UserAvatar',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export enum UploadFileType {
  CustomerOrder = 'CustomerOrder',
  Full = 'Full',
  Middle = 'Middle',
  Thumb = 'Thumb',
}

export type UploadQueue = {
  __typename?: 'UploadQueue';
  context: Maybe<Scalars['String']['output']>;
  contextId: Maybe<Scalars['String']['output']>;
  deviceId: Maybe<Scalars['String']['output']>;
  filesCount: Maybe<Scalars['Int']['output']>;
  filesDone: Maybe<Scalars['Int']['output']>;
  onDone: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  progress: Maybe<Scalars['Int']['output']>;
  queueId: Maybe<Scalars['String']['output']>;
  type: Maybe<UploadType>;
};

export enum UploadType {
  App = 'App',
  Browser = 'Browser',
}

export type UserHasConversation = {
  __typename?: 'UserHasConversation';
  context: Maybe<CommentContext>;
  contextId: Maybe<Scalars['ID']['output']>;
  isSeen: Maybe<Scalars['Boolean']['output']>;
  lastAuthor: Maybe<Scalars['String']['output']>;
  lastMessage: Maybe<Scalars['String']['output']>;
  lastMessageDate: Maybe<Scalars['Int']['output']>;
  lastSeen: Maybe<Scalars['Int']['output']>;
  unseenCount: Maybe<Scalars['Int']['output']>;
  userHasConversationId: Maybe<Scalars['ID']['output']>;
};

export enum UserTest {
  AntiAiWatermark = 'AntiAiWatermark',
  AutoSell = 'AutoSell',
  BigUpgrades = 'BigUpgrades',
  BookingLite = 'BookingLite',
  CampaignTrackedShootingCreation = 'CampaignTrackedShootingCreation',
  CountryPricePicker = 'CountryPricePicker',
  DidShop = 'DidShop',
  EmbedStore = 'EmbedStore',
  EmpikFoto = 'EmpikFoto',
  FilePricingAsSourceForPriceToAddToEveryFileInProduct = 'FilePricingAsSourceForPriceToAddToEveryFileInProduct',
  IdentityPhotoSell = 'IdentityPhotoSell',
  KrukBook = 'KrukBook',
  Notifications = 'Notifications',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  PermissionsCollection = 'PermissionsCollection',
  PrintOwnPhotos = 'PrintOwnPhotos',
  PrivateSession = 'PrivateSession',
  PrivateSessionLookBook = 'PrivateSessionLookBook',
  PublicSessionSignupCampaigns = 'PublicSessionSignupCampaigns',
  PublicSessionTemplates = 'PublicSessionTemplates',
  ScreenAppProtection = 'ScreenAppProtection',
  ScreenAppProtectionn = 'ScreenAppProtectionn',
  SellTriplex = 'SellTriplex',
  SellZalamoFrames = 'SellZalamoFrames',
  SnapPremiumPackage = 'SnapPremiumPackage',
  TabloDesigner = 'TabloDesigner',
  TestPremiumLab = 'TestPremiumLab',
  VisualGuides = 'VisualGuides',
  ZalamoPrintExperience = 'ZalamoPrintExperience',
  Csv = 'csv',
}

export enum UserType {
  Admin = 'Admin',
  Anonymous = 'Anonymous',
  CampaignManager = 'CampaignManager',
  Client = 'Client',
  CompetitionMember = 'CompetitionMember',
  Lab = 'Lab',
  LabEmployee = 'LabEmployee',
  LabManager = 'LabManager',
  LabOutsource = 'LabOutsource',
  LookbookMaestro = 'LookbookMaestro',
  MobileNativeClient = 'MobileNativeClient',
  OrdersManager = 'OrdersManager',
  PhotoFaceMatch = 'PhotoFaceMatch',
  Photographer = 'Photographer',
  RetouchManager = 'RetouchManager',
  Retoucher = 'Retoucher',
  Support = 'Support',
  WeddingCouple = 'WeddingCouple',
}

export enum VatType {
  Applied = 'Applied',
  Exempt = 'Exempt',
}

export type WallDecorPieceCrop = {
  __typename?: 'WallDecorPieceCrop';
  h: Maybe<Scalars['Float']['output']>;
  w: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type WallDecorPieceCropInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type WallDecorRenderPieceConfig = {
  __typename?: 'WallDecorRenderPieceConfig';
  crop: Maybe<WallDecorPieceCrop>;
  isFlip: Maybe<Scalars['Boolean']['output']>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  wallDecorPieceId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPieceConfigInput = {
  crop: WallDecorPieceCropInput;
  isFlip: Scalars['Boolean']['input'];
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  wallDecorPieceId: Scalars['ID']['input'];
};

export type WallDecorRenderPreviewConfig = {
  __typename?: 'WallDecorRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  color: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  wallDecorRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  wallDecorSceneId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPreviewConfigInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  wallDecorSceneId?: InputMaybe<Scalars['ID']['input']>;
};

export type ZalamoFramesStats = {
  __typename?: 'ZalamoFramesStats';
  enabled: Maybe<Array<Maybe<PublicSessionSellingZalamoFrames>>>;
};

export type ZalamoImagePerformance = {
  __typename?: 'ZalamoImagePerformance';
  avg: Maybe<Scalars['Int']['output']>;
  count: Maybe<Scalars['Int']['output']>;
  p25: Maybe<Scalars['Int']['output']>;
  p50: Maybe<Scalars['Int']['output']>;
  p75: Maybe<Scalars['Int']['output']>;
  p90: Maybe<Scalars['Int']['output']>;
  p100: Maybe<Scalars['Int']['output']>;
  time: Maybe<Scalars['Int']['output']>;
};

export type ZalamoKnowledgeBaseEntry = {
  __typename?: 'ZalamoKnowledgeBaseEntry';
  aliases: Array<Scalars['String']['output']>;
  answer: Scalars['String']['output'];
  category: Scalars['String']['output'];
  firstSeenAt: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  lastSeenAt: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  score: Maybe<Scalars['Float']['output']>;
  sourceThreadIds: Array<Scalars['String']['output']>;
  zalamoKnowledgeBaseEntryId: Scalars['ID']['output'];
};

export type ZalamoKnowledgeBaseSearchResult = {
  __typename?: 'ZalamoKnowledgeBaseSearchResult';
  analyzedThreadsCount: Scalars['Int']['output'];
  entriesCount: Scalars['Int']['output'];
  generatedAt: Scalars['String']['output'];
  query: Scalars['String']['output'];
  results: Array<ZalamoKnowledgeBaseEntry>;
  sourceLabel: Scalars['String']['output'];
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export type ZalamoPayP24RegisterInput = {
  addressCity: Scalars['String']['input'];
  addressPostCode: Scalars['String']['input'];
  addressStreet: Scalars['String']['input'];
  bankAccount: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  contactPersonName: Scalars['String']['input'];
  contactPersonPhoneNumber: Scalars['String']['input'];
  correspondenceAddressCity: Scalars['String']['input'];
  correspondenceAddressPostCode: Scalars['String']['input'];
  correspondenceAddressStreet: Scalars['String']['input'];
  krs: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nip: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  regon: Scalars['String']['input'];
  representatives: Array<InputMaybe<ZalamoPayP24RepresentativeInput>>;
};

export type ZalamoPayP24RepresentativeInput = {
  name: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
};

export type ZalamoPayPayment = {
  __typename?: 'ZalamoPayPayment';
  context: ZalamoPaymentContext;
  contextId: Scalars['ID']['output'];
  paid: Maybe<Scalars['Boolean']['output']>;
  zalamoPayPaymentId: Scalars['ID']['output'];
};

export type ZalamoPayRegisterResponse = {
  __typename?: 'ZalamoPayRegisterResponse';
  link: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type ZalamoPayStats = {
  __typename?: 'ZalamoPayStats';
  errors: Maybe<Scalars['Int']['output']>;
  todayCount: Maybe<Scalars['Int']['output']>;
};

export enum ZalamoPaymentContext {
  DesignerTemplateOrder = 'DesignerTemplateOrder',
  MarketplaceOrder = 'MarketplaceOrder',
  Order = 'Order',
  PublicSessionSignupSubmission = 'PublicSessionSignupSubmission',
}

export type ZalamoPrintSessionConfig = {
  __typename?: 'ZalamoPrintSessionConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  calendarPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  enabledTabloSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  magnetPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tabloPricing: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  zalamoPrintSessionConfigId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  enabledTabloSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  magnetPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  sellCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sellMagnet?: InputMaybe<Scalars['Boolean']['input']>;
  sellTablo?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tabloPricing?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
};

export type ZalamoPrintSessionTabloConfig = {
  __typename?: 'ZalamoPrintSessionTabloConfig';
  formatLabel: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  tabloIndex: Maybe<Scalars['Int']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfig = {
  __typename?: 'ZalamoPrintSessionTabloPricingConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfigInput = {
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ZalamoSupportContext {
  Client = 'Client',
  LookbookMaestro = 'LookbookMaestro',
  MobileNativeClient = 'MobileNativeClient',
  OrdersManager = 'OrdersManager',
  Photographer = 'Photographer',
  Support = 'Support',
  WeddingCouple = 'WeddingCouple',
}
